import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import {
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Theme from './Theme.js'
import { ColorPicker } from 'primereact/colorpicker';
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import Config from "../../Config.js";
import swal from "sweetalert";
import DataTable from "react-data-table-component";
import QRCode from "qrcode.react";
import jsPDF from "jspdf";
import Select from "react-select";
import DatePicker from "react-datepicker";
import Moment from "moment";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";
import {
  Checkexportdata,
  CheckCheckAPDynamicQrCodeCountenabled,
  CheckBulkQRcodecount,
} from "../../api/packageApi";
import {
  GetDominUrl
} from "../../api/apiconfiguration.js";

import "react-datepicker/dist/react-datepicker.css";
// import EmailShare from 'react-email-share-link'
require("codemirror/mode/xml/xml.js");
require("codemirror/mode/javascript/javascript.js");

const Productqrcode = (props) => {
  let history = useHistory();
  const [rolename, setroleName] = useState(
    localStorage.getItem("loginRoleName")
  );
  const [LabelList, setLabelList] = useState([]);
  const [subcetgoryList, setsubcetgoryList] = useState([]);
  const [CategoryList, setCategoryList] = useState([]);
  const [ArticlesTypeList, setArticlesTypeList] = useState([]);
  const [SupplierList, setSupplierList] = useState([]);
  const [ArticlesTypeId, setArticlesTypeId] = useState("");
  const [CategoryId, setCategoryId] = useState("");
  const [CategoryError, setCategoryError] = useState("");
  const [LabelId, setLabelId] = useState("");
  const [LabelError, setLabelError] = useState("");
  const [SupplierId, setSupplierId] = useState("");
  const [SupplierError, setSupplierError] = useState("");
  const [variationlistmodal, setvariationlistmodal] = useState(false);
  const [qrmodal, setqrmodal] = useState(false);
  const [TotalQrcodelist, setTotalQrcodelist] = useState([]);
  const [totalQrcodeArticlename, settotalQrcodeArticlename] = useState("");
  const [totalQrcodeArticlenumber, settotalQrcodeArticlenumber] = useState("");
  const [totalQrcodeCreatedDate, settotalQrcodeCreatedDate] = useState("");
  const [QrCodeModalisOpen, setQrCodeModalisOpen] = useState(false);
  const [selectCombinationID, setselectCombinationID] = useState("");
  const [selectCombination, setselectCombination] = useState("");
  const [QrCodeString, setQrCodeString] = useState("");
  const [ArticleId, setArticleId] = useState("");
  const [ArticleName, setArticleName] = useState("");
  const [totalQrcodeImage, settotalQrcodeImage] = useState("");
  const [totalQrcodecategory, settotalQrcodecategory] = useState("");
  const [ProductqrcodeList, setProductqrcodelist] = useState([]);
  const [PerPageCount, setPerPageCount] = useState(10);
  const [TotalCount, setTotalCount] = useState(0);
  const [SortColumnType, setSortColumnType] = useState("Desc");
  const [SortColumn, setSortColumn] = useState("createdDate");
  const [SearchValue, setSearchValue] = useState("");
  const [CurrentPageNo, setCurrentPageNo] = useState(1);
  const [ShowPaggingCount, setShowPaggingCount] = useState(4);
  const [PaginationGroupList, setPaginationGrouplist] = useState([]);
  const [canPreviousPage, setcanPreviousPage] = useState(false);
  const [canNextPage, setcanNextPage] = useState(true);
  const [ProductNameError, setProductNameError] = useState("");
  const [ProductName, setProductName] = useState("");
  const [Username, setUsername] = useState("");
  const [UsernameError, setUsernameError] = useState("");
  const [ArticleSKU, setArticleSKU] = useState("");
  const [PaggingList, setPaggingList] = useState([]);
  const [ArticlesNo, setArticlesNo] = useState("");
  const [EnableEWarranty, setEnableEWarranty] = useState(false);
  const [ArticlesName, setArticlesName] = useState("");
  const [ArticlescategoryName, setArticlescategoryName] = useState("");
  const [ArticlessubcategoryName, setArticlessubcategoryName] = useState("");
  const [ArticlesProfileImage, setArticlesProfileImage] = useState("");
  const [selectedData, setSelectedData] = React.useState([]);
  const [ArticlesVariationList, setArticlesVariationList] = useState([]);
  const [ArticlesVariationListTemp, setArticlesVariationListTemp] = useState(
    []
  );
  const [ArticlesQrcodeList, setArticlesQrcodeList] = useState([]);
  const [TotalQrcodeModel, setTotalQrcodeModel] = useState(false);
  const [selectproductid, setselectproductid] = useState(false);

  const [Qrcodestring, setQrcodestring] = useState("");
  const [modalArticleQroce, setmodalArticleQroce] = useState(false);
  const [QrcodeProductname, setQrcodeProductname] = useState("");
  const [subcategoryId, setsubcategoryId] = useState("");
  const [subcategoryIdError, setsubcategoryIdError] = useState("");
  const [issubcategoryshow, setissubcategoryshow] = useState(false);
  const [userLoaded, setUserLoaded] = useState(false);
  const [IsPublished, setIsPublished] = useState("");
  const [TotleCountPublished, setTotleCountPublished] = useState(0);

  const [subuserlist, setsubuserlist] = useState([]);
  const [selectuserID, setselectuserID] = useState("");
  const [selectuseronlyID, setselectuseronlyID] = useState("");

  const [subToEmail, setsubToEmail] = useState([]);
  const [isToEamil, setisToEamil] = useState(false);
  const [isToEamilBulk, setisToEamilBulk] = useState(false);
  const [isToEamilAttribute, setisToEamilAttribute] = useState(false);
  const [ToemailEmptyError, setToemailEmptyError] = useState("");
  const [isToemailMaltiple, setisToemailMaltiple] = useState(false);
  const [DuplicateQrcodeList, setDuplicateQrcodeList] = useState([]);
  const [QrcodeQty, setQrcodeQty] = useState(0);
  const [modalQrcode, setmodalQrcode] = useState(false);
  const [bulkQrcodeInformation, setbulkQrcodeInformation] = useState("");
  const [isDuplicateToEamil, setisDuplicateToEamil] = useState(false);
  const [QrCodeID, setQrCodeID] = useState("");

  //new product qrcode
  const [NewProductQrCodeisOpen, setNewProductQrCodeisOpen] = useState(false);
  const [newqrcodeid, setnewqrcodeid] = useState("");
  const [NewQrCodeString, setNewQrCodeString] = useState("");
  const [VendorID, setVendorID] = useState("");
  const [vendorlist, setvendorlist] = useState([]);
  const [isAttributeshow, setisAttributeshow] = useState(false);
  const [CombinationList, setCombinationList] = useState([]);
  const [selectBatchNumbername, setselectBatchNumbername] = useState("");
  const [BatchNumber, setBatchnumber] = useState("");
  const [batchNumberList, setbatchNumberList] = useState([]);
  const [ManufactureDate, setManufactureDate] = useState(null);
  const [ManufactureDateFinal, setManufactureDateFinal] = useState(null);
  const [ExpiryDate, setExpiryDate] = useState(null);
  const [ExpiryDateFinal, setExpiryDateFinal] = useState(null);
  const [QrCodeStringArticle, setQrCodeStringArticle] = useState("");
  const [BatchNumberError, setBatchNumberError] = useState("");
  const [batchnumberisOpen, setBatchnumberisOpen] = useState(false);
  const [ArticlessubcategoryNewName, setArticlessubcategorynewName] =
    useState("");
  const [selectCombinationNewID, setselectCombinationNewID] = useState("");
  const [QrCodeStringnew, setQrCodeStringnew] = useState("");
  const [QrCodeqrcodeIDnew, setQrCodeqrcodeIDnew] = useState("");
  const [isrefresh, setisrefresh] = useState(false);
  const [isBindAttributeLoding, setisBindAttributeLoding] = useState(false);

  //Data table
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [action] = useState({ fromUser: false });

  const [PreviewModalisOpen, setPreviewModalisOpen] = useState(false);

  const [titlefontsize, settitlefontsize] = useState(16);
  const [titlefontsizeFinal, settitlefontsizeFinal] = useState("16Px");
  const [IsBackgroundUrl, setIsBackgroundUrl] = useState(false);
  const [selectedOptionBackgroundColor, setselectedOptionBackgroundColor] = useState(false);
  const [descriptionfontsize, setdescriptionfontsize] = useState(16);
  const [descriptionfontsizeFinal, setdescriptionfontsizeFinal] = useState("16px");
  const [ckeditorTitleFontSize, setCkeditorTitleFontSize] = useState(16);
  const [ckeditorTitleFontSizeFinal, setCkeditorTitleFontSizeFinal] = useState("16px");
  const [ckeditorDescriptionFontSize, setCkeditorDescriptionFontSize] = useState(16);
  const [ckeditorDescriptionFontSizeFinal, setCkeditorDescriptionFontSizeFinal] = useState("16px");
  const [pageBackgroundImage, setpageBackgroundImage] = useState('');

  const [productinfo, setproductinfo] = useState(null);
  const [isLoading, setisLoading] = useState(false);
  const [Collapseidlist, setCollapseidlist] = useState([]);
  const [defaultThemelistTemp, setDefaultThemelistTemp] = useState([]);
  const [defaultThemelist, setDefaultThemelist] = useState([]);
  const [uploadBackgroundImage, setuploadBackgroundImage] = useState(null);
  const [productQrcodeThemeId, setProductQrcodeThemeId] = useState("");
  const [defaultThemeId, setDefaultThemeId] = useState("");
  const [Color1, setColor1] = useState("#0a0303");
  const [Color2, setColor2] = useState("#01F9C6");
  const [Color3, setColor3] = useState("#617C58");
  const [Sliderimground, setSliderimground] = useState("");
  const [isbuttonLoading, setisbuttonLoading] = useState(false);
  const [logoshadow, setlogoshadow] = useState(1);
  const [logoshadowFinal, setlogoshadowFinal] = useState("1px",);
  const [iscertificatesopen, setiscertificatesopen] = useState(false);
  const [issuccess, setissuccess] = useState(false);
  const [iserror, setiserror] = useState(false);
  const domainFrontUrl = useRef("");

  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === null ||
      checkLogin === "null" ||
      checkLogin === undefined
    ) {
      history.push("/Login");
    } else {
      getDominUrl();
      GetAllDropdwonArticle();
      GetalldefaultTheme();
      GetAllCategory();
      GetAllvendor();
      if (rolename === "Admin" || rolename === "SuperAdmin") {
        GetadminaandAllsubuser();
      }
    }
  }, []);

  const getDominUrl = async () => {
    let response = await GetDominUrl();
    if (response !== null && response.domainName !== null && response.domainName !== "") {
      domainFrontUrl.current = response.domainName;
    }
    else {
      domainFrontUrl.current = "";
    }
  }

  useEffect(() => {
    setPaggingDDL();
    getPaginationGroup();
  }, [TotalCount]);

  useEffect(() => {
    getData();
  }, [PerPageCount, SortColumnType, CurrentPageNo, userLoaded]);

  const GetAllDropdwonArticle = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let EmaptyArrry = [];
    fetch(Config.apiUrl + "ArticleProduct/AllDropdwon", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        if (result.labelDetail.length > 0) {
          setLabelList(result.labelDetail);
        } else {
          setLabelList(EmaptyArrry);
        }

        // if (result.categorydetail.length > 0) {
        //     setCategoryList(result.categorydetail);
        // }
        // else {
        //     setCategoryList(EmaptyArrry);
        // }

        if (result.articletype.length > 0) {
          setArticlesTypeList(result.articletype);
        } else {
          setArticlesTypeList(EmaptyArrry);
        }

        if (result.supplierdetail.length > 0) {
          setSupplierList(result.supplierdetail);
        } else {
          setSupplierList(EmaptyArrry);
        }
      });
    });
  };

  const GetadminaandAllsubuser = async () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl + "UserCompany/GetadminaandAllsubuser?isadmin=" + false,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((responseJson) => {
        setsubuserlist(responseJson);
      })
      .catch((error) => {
        // setIsloading(false)
        // document.body.style.overflow = 'auto';
        console.log(error);
        setsubuserlist([]);
      });
  };
  const GetAllCategory = () => {
    let loginid = localStorage.getItem("loginUserID");
    let EmaptyArrry = [];
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(Config.apiUrl + "Category/CategoryListwithsubcategory", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        if (result.length > 0) {
          setCategoryList(result);
        } else {
          setCategoryList(EmaptyArrry);
        }
      });
    });
  };

  const getData = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    setTotalCount(0);
    let subUserIDList = localStorage.getItem("subUserIDList");
    fetch(
      Config.apiUrl +
      "ArticleProduct/ProductPagination?SortingColumnName=" +
      SortColumn +
      "&AscDesc=" +
      SortColumnType +
      "&PageNo=" +
      CurrentPageNo +
      "&PageSize=" +
      PerPageCount +
      "&SearchQuery=" +
      SearchValue +
      "&articleName=" +
      ProductName +
      "&categoryId=" +
      CategoryId +
      "&subcategoryId=" +
      subcategoryId +
      "&labelId=" +
      LabelId +
      "&supplierId=" +
      SupplierId +
      "&articleTypeId=" +
      ArticlesTypeId +
      "&isPublished=" +
      IsPublished +
      "&user=" +
      selectuseronlyID +
      "&sku=" +
      ArticleSKU,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          subUserCompanyID: subUserIDList,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result !== null) {
          if (
            result.articleProductList.length > 0 &&
            result.articleProductList != null
          ) {
            setTotalCount(result.totalCount);
            setProductqrcodelist(result.articleProductList);
            setTotleCountPublished(result?.totalPublishedCount);
          } else {
            setTotalCount(0);
            setProductqrcodelist([]);
            setTotleCountPublished(0);
          }
          //getPaginationGroup();
        } else {
          setTotalCount(0);
          setTotleCountPublished(0);
          setProductqrcodelist([]);
          //getPaginationGroup();
        }
      });
    });
  };
  const onChangeSubCategory = (event) => {
    setsubcategoryId(event.target.value);
    setsubcategoryIdError("");
  };
  const handleChangeCategory = () => {
    if (issubcategoryshow === true) {
      setsubcategoryId("");
    }
    setissubcategoryshow(!issubcategoryshow);
  };

  const onChangeCategory = (event) => {
    let catId = event.target.value;
    setCategoryId(event.target.value);
    setCategoryError("");
    if (CategoryList.length > 0);
    {
      var subCategoryDetailList = CategoryList.find(
        (x) => x._id === event.target.value
      );
      if (subCategoryDetailList != undefined) {
        setsubcetgoryList(subCategoryDetailList.subCategoryModelList);
      } else {
        setsubcetgoryList([]);
      }
    }
  };
  const onChangeLabeldrop = (event) => {
    let lablId = event.target.value;
    setLabelError("");
    setLabelId(event.target.value);
  };
  const onChangeSupplierdroptype = (event) => {
    let suplierId = event.target.value;
    setSupplierError("");
    setSupplierId(event.target.value);
  };

  const GoToProductinformationPage = (ProductID) => {
    //history.push("/productinformation");
    history.push({
      pathname: "/product-information",
      state: { ProductID: ProductID },
    });
  };
  const OnchangedtotalQrcode = (PID) => {
    console.log("PID====>", PID?._id);
    if (PID !== null && PID !== "" && PID !== undefined) {
      getBulkQrCodeData(PID?._id);
      let FullPath = `${Config.contentUrl + PID?.articlePics}`;
      settotalQrcodeArticlename(PID?.articleName);
      settotalQrcodeImage(FullPath);
      if (
        PID?.categoryID !== null &&
        PID?.categoryID !== null &&
        PID?.categoryID !== ""
      ) {
        settotalQrcodecategory(
          PID?.categorydetail?.name + " /  " + PID?.subCategoryDetail?.name
        );
      } else {
        settotalQrcodecategory("");
      }
      let date = new Date(PID.createdDate);
      let dateMDY = `${date.getDate()}-${date.getMonth() + 1
        }-${date.getFullYear()}`;
      settotalQrcodeCreatedDate(dateMDY);
      settotalQrcodeArticlenumber(PID?.articleNumber);
      // let loginid = localStorage.getItem("loginUserID");
      // let Auth0token = localStorage.getItem('Auth0token')
      // fetch(Config.apiUrl + 'QrCodeResourceController/GetAllQrcodeList?ProductID=' + PID?._id,
      //     {
      //         method: 'GET',
      //         headers: {
      //             'Content-Type': 'application/json',
      //             "userCompanyID": loginid,
      //             Authorization: 'Bearer ' + Auth0token,
      //         },
      //     }).then((resp1) => {
      //         resp1.json().then((result) => {
      //             if (result.length > 0 && result !== null) {
      //                 console.log("resultQrCodeInfo====>", result)
      //                 setTotalQrcodeModel(true)
      //                 setTotalQrcodelist(result)
      //             }
      //             else {
      //                 setTotalQrcodeModel(true)
      //                 setTotalQrcodelist([])
      //             }
      //         })
      //     })
    }
  };
  const getBulkQrCodeData = (productId) => {
    if (productId !== null && productId !== "" && productId !== undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/GetAllQrcodeList?ProductID=" +
        productId,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result.length > 0 && result !== null) {
            console.log("resultQrCodeInfo====>", result);
            setselectproductid(productId);
            setTotalQrcodeModel(true);
            setTotalQrcodelist(result);
          } else {
            setTotalQrcodeModel(true);
            setTotalQrcodelist([]);
          }
        });
      });
    }
  };
  const TotalQrcodeModelclose = () => {
    setTotalQrcodeModel(false);
  };
  const columns = useMemo(
    () => [
      {
        Header: "Sr. #",
        accessor: "srnoumber",
        selector: "srnoumber.",
        sortable: true,
        Cell: (row) => {
          {
            return (
              <span className="mb-0" style={{ width: "20px" }}>
                {row?.row?.original?.sr}
              </span>
            );
          }
        },
      },
      {
        Header: "Image",
        accessor: "articleImage",
        selector: "ArticleImage",
        sortable: false,
        Cell: (row) => {
          let FullPath = `${Config.contentUrl + row?.row?.original?.articlePics
            }`;
          {
            return row?.row?.original?.articlePics != null &&
              row?.row?.original?.articlePics != "" ? (
              <img
                src={FullPath}
                className="table-main-image btn-shadow"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = "../assets/img/new-images/images.png";
                }}
                onClick={(e) => {
                  GoToProductinformationPage(row?.row?.original?._id);
                }}
              ></img>
            ) : (
              <img
                src="../assets/img/new-images/images.png"
                style={{ height: "50px", cursor: "pointer" }}
                onClick={(e) => {
                  GoToProductinformationPage(row.row.original._id);
                }}
              ></img>
            );
          }
        },
      },
      {
        Header: "Name",
        accessor: "articleName",
        selector: "articleName",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          {
            return row?.row?.original?.articleName != null &&
              row?.row?.original?.articleName != "" ? (
              // <p>{row.row.original.articleType.name}</p>
              <div className="articletypebtn">
                <div className="data-scroll">
                  <p className="mb-0">{row.row.original.articleName}</p>
                </div>

                {row?.row?.original?.articleTypeID !== null &&
                  row?.row?.original?.articleTypeID !== "" ? (
                  row?.row?.original?.articleType._id ===
                    "62ac68e2830ffdde1c0b09b9" ? (
                    <button
                      type="button"
                      onClick={() => {
                        ProductVariations(row?.row?.original?._id);
                      }}
                      className="btn btn-link p-0 cursor-pointer"
                    >
                      <i class="ion ion-md-add-circle fa-2x fa-fw text-black-lighter"></i>
                    </button>
                  ) : (
                    <></>
                  )
                ) : (
                  <></>
                )}
              </div>
            ) : (
              ""
            );
          }
        },
      },

      {
        Header: "QR Code",
        accessor: "articleQrcode",
        selector: "articleQrcode",
        sortable: false,

        Cell: (row) => {
          //let FullPathQrcode = `${Config.contentUrl+row.row.original.qrCodePath}`;
          return row?.row?.original?.qrCodePath !== null &&
            row?.row?.original?.qrCodePath !== "" &&
            row?.row?.original?.qrCodePath !== undefined ? (
            <div>
              <button
                className={
                  "m-t-5 btn btn-white btn-shadow p-2 border " +
                  (row?.row?.original?.isPublished === false
                    ? "border-danger"
                    : "")
                }
                onClick={() => {
                  toggleqr(row?.row?.original);
                }}
              >
                <img
                  src="../assets/img/user/QR.png"
                  alt="img"
                  style={{ height: "40px" }}
                  onerror="this.src='../assets/img/new-images/images.png';"
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>
                  {row?.row?.original?.isPublished === false ? "Pause" : "Play"}
                </b>
              </p>
            </div>
          ) : row?.row?.original?.isshow === true ? (
            <div>
              <button
                className={
                  "m-t-5 btn btn-white btn-shadow p-2 border " +
                  (row.row.original.isPublished === false
                    ? "border-danger"
                    : "")
                }
                onClick={(e) => {
                  //EditArticleDetails(row?.row?.original?._id);
                  toggleNewProductQrCodeisOpen(row?.row?.original);
                }}
              >
                <img
                  src="/assets/img/new-Images/qr-code-scanner.jpg"
                  style={{ height: "40px", width: "40px" }}
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>
                  {row?.row?.original?.isPublished === false ? "Pause" : "Play"}
                </b>
              </p>
            </div>
          ) : (
            <>
              <div>
                <button
                  className={
                    "m-t-5 btn btn-white btn-shadow p-2 border " +
                    (row.row.original.isPublished === false
                      ? "border-danger"
                      : "")
                  }
                  onClick={(e) => {
                    swal("  Oops... not allowed ! ");
                  }}
                >
                  <img
                    src="/assets/img/new-Images/qr-code-scanner.jpg"
                    style={{ height: "40px", width: "40px" }}
                  ></img>
                </button>
                <p className="small text-center m-t-5">
                  <b>
                    {row?.row?.original?.isPublished === false
                      ? "Pause"
                      : "Play"}
                  </b>
                </p>
              </div>
            </>
          );
        },
      },

      {
        Header: "Qty",
        accessor: "totalQrcode",
        selector: "TotalQrcode",
        //sortable: true,
        sortable: false,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          //let FullPathQrcode = `${Config.contentUrl+row.row.original}`;
          return (
            // <button className='btn btn-link btn-sm btn-text'>
            //     <p className='mb-0'>{row.row.original.totalQrcode}</p>
            // </button>

            <button
              className="btn btn-link btn-sm btn-text"
              onClick={() => {
                OnchangedtotalQrcode(row?.row?.original);
              }}
            >
              <p className="mb-0">{row?.row?.original?.totalQrcode}</p>
            </button>
          );
        },
      },
      {
        Header: "Scans",
        accessor: "totalScans",
        selector: "totalScans",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          {
            return row?.row?.original?.totalScans != null &&
              row?.row?.original?.totalScans != "" ? (
              <div className="">
                <p className="m-0">{row?.row?.original?.totalScans}</p>
                {row?.row?.original?.isshow === true ? (
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      gotoreports(row?.row?.original?._id);
                    }}
                  >
                    <img
                      src="../assets/img/user/graph.png"
                      style={{ height: "30px" }}
                    ></img>
                  </button>
                ) : (
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      swal("Oops... not allowed ! ");
                    }}
                  >
                    <img
                      src="../assets/img/user/graph.png"
                      style={{ height: "30px" }}
                    ></img>
                  </button>
                )}
              </div>
            ) : (
              <div className="">
                <p className="m-0">0</p>
                {row?.row?.original?.isshow === true ? (
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      gotoreports(row?.row?.original?._id);
                    }}
                  >
                    <img
                      src="../assets/img/user/graph.png"
                      style={{ height: "30px" }}
                    ></img>
                  </button>
                ) : (
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      swal("Oops... not allowed ! ");
                    }}
                  >
                    <img
                      src="../assets/img/user/graph.png"
                      style={{ height: "30px" }}
                    ></img>
                  </button>
                )}
              </div>
            );
          }
        },
      },
      {
        Header: "Article",
        accessor: "articleNumber",
        selector: "articleNumber",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          {
            return row?.row?.original?.articleNumber != null &&
              row?.row?.original?.articleNumber != "" ? (
              <div className="articletypebtn">
                <div className="onlydata-scroll">
                  <p className="mb-0">{row?.row?.original?.articleNumber}</p>
                </div>
              </div>
            ) : (
              ""
            );
          }
        },
      },
      {
        Header: "Category",
        accessor: "category",
        selector: "categoryid",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          //let FullPathQrcode = `${row.row.original.categorydetail.name}`;
          {
            return row?.row?.original?.categorydetail?._id != null &&
              row?.row?.original?.categorydetail?._id != "" ? (
              <div className="onlydata-scroll" style={{ width: "200px" }}>
                <p>
                  {row?.row?.original?.categorydetail.name}
                  {row?.row?.original?.subCategoryDetail?._id != null &&
                    row?.row?.original?.subCategoryDetail?._id != "" ? (
                    <p>/ {row.row.original.subCategoryDetail.name}</p>
                  ) : (
                    ""
                  )}
                </p>
              </div>
            ) : (
              ""
            );
          }
        },
      },
      {
        Header: "Created Date",
        accessor: "createdDate",
        selector: "createdDate",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          let date = new Date(row?.row?.original?.createdDate);
          let dateMDY = `${date.getDate()}-${date.getMonth() + 1
            }-${date.getFullYear()}`;
          return <span>{dateMDY}</span>;
        },
      },
      {
        Header: "Owner",
        accessor: "Owner",
        selector: "Owner",
        sortable: false,
        Cell: (row) => {
          let FullOwnerpath = `${Config.contentUrl + row.row.original.ownerImage
            }`;
          return (
            //<img src={FullPathQrcode} alt="img" style={{ height: '40px' }}></img>
            <div className="data-scroll">
              <img
                src={FullOwnerpath}
                className="rounded-circle"
                style={{ height: "40px", width: "40px", objectFit: "cover" }}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = "../assets/img/new-images/images.png";
                }}
              ></img>
              {/* <img src="../assets/img/user/user-1.jpg" alt="img" style={{ height: '40px', }} className='rounded-circle'></img> */}
              <p>{row.row.original.ownerName}</p>
            </div>
          );
        },
      },
      // {
      //     Header: 'SKU',
      //     accessor: 'articleSKU',
      //     selector: 'articleSKU',
      //     sortable: true,
      //     headerClassName: 'rt-tr-align-right',
      // },
      {
        Header: " Actions",
        accessor: "col13",
        sortable: false,
        Cell: (row) => {
          return (
            <div style={{ width: "100%" }}>
              {row?.row?.original?.isshow === true ? (
                <>
                  <button
                    type="button"
                    className="btn btn-primary  btn-sm mr-2 mt-2"
                    onClick={(e) => {
                      EditArticleDetails(row?.row?.original?._id);
                    }}
                  >
                    <i className="ion ion-md-create "></i>
                  </button>

                  {row?.row?.original?.qrCodePath !== null &&
                    row?.row?.original?.qrCodePath !== "" ? (
                    <UncontrolledButtonDropdown>
                      <DropdownToggle className="btn btn-warning ellipsis-btn btn-sm mt-2">
                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </DropdownToggle>
                      <DropdownMenu style={{ overflowY: 'scroll', height: '150px' }}>
                        <DropdownItem
                          onClick={(e) => {
                            row?.row?.original?.isPublished === false
                              ? ArticlePlay(row?.row?.original?._id)
                              : ArticlePlayAllreadyplay();
                          }}
                        >
                          <i className="fas fa-play m-r-10"></i>
                          Play
                        </DropdownItem>
                        <DropdownItem divider></DropdownItem>
                        <DropdownItem
                          onClick={(e) => {
                            row?.row?.original?.isPublished === false
                              ? ArticlePlayAllreadypush()
                              : ArticlePause(row?.row?.original?._id);
                          }}
                        >
                          <i className="fas fa-pause m-r-10"></i>
                          Pause
                        </DropdownItem>
                        <DropdownItem divider></DropdownItem>
                        <DropdownItem
                          className="text-danger"
                          onClick={(e) => {
                            DeleteArticleDetails(row?.row?.original?._id);
                          }}
                        >
                          <i className="fas fa-trash m-r-10"></i>
                          Delete
                        </DropdownItem>
                        <DropdownItem divider></DropdownItem>
                        <DropdownItem
                          onClick={(e) => {
                            toggleNewProductQrCodeisOpen(row?.row?.original);
                          }}
                        >
                          {/* <i className="fa-regular fa-qrcode"></i> */}
                          <i className="fa fa-expand m-r-10"></i>
                          Qrcode
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledButtonDropdown>
                  ) : (
                    <UncontrolledButtonDropdown>
                      <DropdownToggle className="btn btn-warning  ellipsis-btn btn-sm mt-2">
                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </DropdownToggle>
                      <DropdownMenu style={{ overflowY: 'scroll', height: '150px' }}>
                        <DropdownItem
                          onClick={(e) => {
                            swal("Oops... Your Qrcode Not Generate ! ");
                          }}
                        >
                          <i className="fas fa-play m-r-10"></i>
                          Play
                        </DropdownItem>
                        <DropdownItem divider></DropdownItem>
                        <DropdownItem
                          onClick={(e) => {
                            swal("Oops... Your Qrcode Not Generate ! ");
                          }}
                        >
                          <i className="fas fa-pause m-r-10"></i>
                          Pause
                        </DropdownItem>
                        <DropdownItem divider></DropdownItem>
                        <DropdownItem
                          className="text-danger"
                          onClick={(e) => {
                            DeleteArticleDetails(row?.row?.original?._id);
                          }}
                        >
                          <i className="fas fa-trash m-r-10"></i>
                          Delete
                        </DropdownItem>
                        <DropdownItem divider></DropdownItem>
                        <DropdownItem
                          onClick={(e) => {
                            toggleNewProductQrCodeisOpen(row?.row?.original);
                          }}
                        >
                          <i className="fa-regular fa-qrcode m-r-10"></i>
                          Qrcode
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledButtonDropdown>
                  )}
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm mr-2"
                    onClick={(e) => {
                      swal("  Oops... not allowed ! ");
                    }}
                  >
                    <i className="ion ion-md-create "></i>
                  </button>
                  <UncontrolledButtonDropdown>
                    <DropdownToggle className="btn btn-warning ellipsis-btn btn-sm">
                      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </DropdownToggle>
                    <DropdownMenu style={{ overflowY: 'scroll', height: '150px' }}>
                      <DropdownItem
                        onClick={(e) => {
                          swal("  Oops... not allowed ! ");
                        }}
                      >
                        <i className="fas fa-play m-r-10"></i>
                        Play
                      </DropdownItem>
                      <DropdownItem divider></DropdownItem>
                      <DropdownItem
                        onClick={(e) => {
                          swal("  Oops... not allowed ! ");
                        }}
                      >
                        <i className="fas fa-pause m-r-10"></i>
                        Pause
                      </DropdownItem>
                      <DropdownItem divider></DropdownItem>
                      <DropdownItem
                        className="text-danger"
                        onClick={(e) => {
                          swal("  Oops... not allowed ! ");
                        }}
                      >
                        <i className="fas fa-trash m-r-10"></i>
                        Delete
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledButtonDropdown>
                </>
              )}

              <button
                type="button"
                className="btn btn-info btn-sm ml-2  mt-2"
                onClick={(e) => {
                  togglepreviewModal(row?.row?.original?._id);
                }}
              >
                <i className="ion ion-md-color-palette"></i>
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    pageOptions,
    toggleAllRowsSelected,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data: ProductqrcodeList,
      manualPagination: true,
      sortable: false,
      manualSortBy: true,
    },
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          _id: "selection",
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  const EditArticleDetails = (ArticleIdObj) => {
    if (ArticleIdObj === "") {
      history.push("Login1");
    } else {
      // history.push({
      //   pathname: "/qrcodemanagement/product-addnew",
      //   state: { EditArticleDetailsID: ArticleIdObj },
      // });
      history.push({
        pathname: "/product-addnew",
        state: { EditArticleDetailsID: ArticleIdObj },
      });
    }
  };
  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = React.useRef();
      const resolvedRef = ref || defaultRef;

      React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate]);

      return (
        <>
          <input type="checkbox" ref={resolvedRef} {...rest} />
        </>
      );
    }
  );
  const gotoPage = () => {
    if (CurrentPageNo > 1) {
      setCurrentPageNo((CurrentPageNo) => CurrentPageNo - 1);
      let temp = Math.ceil(CurrentPageNo - 1);
      if (temp === 1) {
        setcanPreviousPage(false);
      } else {
        setcanPreviousPage(true);
        setcanNextPage(true);
      }
    }
  };

  const nextPage = () => {
    setCurrentPageNo((CurrentPageNo) => CurrentPageNo + 1);
    setcanPreviousPage(true);
    let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);
    let temp = Math.ceil(CurrentPageNo + 1);
    if (temp === PerPageCountobj) {
      setcanNextPage(false);
    }
  };
  const changePage = (event) => {
    const pageNumber = Number(event.target.textContent);
    if (pageNumber === 1) {
      setcanPreviousPage(false);
      setcanNextPage(true);
    } else {
      setcanPreviousPage(true);
    }
    setCurrentPageNo(pageNumber);
    let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);

    if (pageNumber === PerPageCountobj) {
      setcanNextPage(false);
    } else {
      setcanNextPage(true);
    }
  };
  const handlePageCountChange = (event) => {
    setPerPageCount(event);
    setCurrentPageNo(1);
    if (event >= TotalCount) {
      setcanPreviousPage(false);
      setcanNextPage(false);
    } else {
      setcanPreviousPage(false);
      setcanNextPage(true);
    }
  };
  const getPaginationGroup = () => {
    if (TotalCount > 0) {
      let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);
      let start = Math.floor((CurrentPageNo - 1) / PerPageCount) * PerPageCount;
      let LastPageNo = Math.ceil(TotalCount / PerPageCount);
      if (PerPageCountobj === 1) {
        setcanPreviousPage(false);
        setcanNextPage(false);
      }
      let testArray = [];
      for (var tt = 1; tt <= TotalCount; tt++) {
        if (
          tt >= CurrentPageNo - ShowPaggingCount &&
          tt <= CurrentPageNo + ShowPaggingCount
        ) {
          if (tt <= LastPageNo) {
            testArray.push(tt);
          }
        }
      }
      setPaginationGrouplist(testArray);
    }
  };

  const setPaggingDDL = () => {
    var testDDL = [];

    if (TotalCount <= 10) {
      testDDL = [10, TotalCount];
    } else if (TotalCount <= 20) {
      testDDL = [10, 20, TotalCount];
    } else if (TotalCount <= 30) {
      testDDL = [10, 20, 30, TotalCount];
    } else if (TotalCount <= 50) {
      testDDL = [10, 20, 30, 50, TotalCount];
    } else if (TotalCount <= 100) {
      testDDL = [10, 20, 30, 50, 100, TotalCount];
    } else if (TotalCount <= 200) {
      testDDL = [10, 20, 30, 50, 100, 200, TotalCount];
    } else if (TotalCount <= 300) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, TotalCount];
    } else if (TotalCount <= 400) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, 400, TotalCount];
    } else if (TotalCount <= 500) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, 400, 500, TotalCount];
    }

    setPaggingList(testDDL);
  };
  const ArticleDetailsSearch = (itemSearchValue) => {
    const itemlength = itemSearchValue.length;
    if (itemlength > 2) {
      getData();
    }
  };
  const onChangeProductName = (event) => {
    setProductNameError("");
    setProductName(event.target.value);
  };

  const onChangeProductdroptype = (event) => {
    let artId = event.target.value;
    //setArticleTypeError('');
    setArticlesTypeId(artId);
  };
  const ExportDeatlis = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let TotalIteam = [];
    for (let index = 0; index < selectedFlatRows.length; index++) {
      TotalIteam.push(selectedFlatRows[index].original._id);
    }
    if (TotalIteam.length > 0) {
      fetch(Config.apiUrl + "ArticleProduct/Export", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(TotalIteam),
      })
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = "ExportArticleProduct.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();
          deselectAllRows();
        });
    } else {
      swal("Sorry!", "pleace Select Product qrcode !.", "error");
    }
  };
  const deselectAllRows = useCallback(() => {
    Object.keys(selectedRowIds).forEach((key, index) => {
      selectedRowIds[key] = false;
    });
    toggleAllRowsSelected(false);
  }, [selectedRowIds, toggleAllRowsSelected]);
  const ClereHedersearch = () => {
    setArticleSKU("");
    setCategoryError("");
    setCategoryId("");
    setLabelError("");
    setLabelId("");
    setSupplierError("");
    setSupplierId("");
    setArticlesTypeId("");
    setProductNameError("");
    setIsPublished("");
    setProductName("");
    setUsername("");
    setUsernameError("");
    setsubcategoryId("");
    setsubcetgoryList([]);
    setselectuseronlyID("");
    setselectuserID("");
    setissubcategoryshow(false);
    setUserLoaded(!userLoaded);
    //getData()
  };
  const onSelcetdProductDelete = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let TotalIteam = [];
    for (let index = 0; index < selectedFlatRows.length; index++) {
      // TotalIteam.push(selectedFlatRows[index].original._id);
      if (selectedFlatRows[index].original?.isshow === true) {
        TotalIteam.push(selectedFlatRows[index].original._id);
      } else {
        swal("Oops... not allowed ! ");
        return;
      }
    }
    if (TotalIteam.length > 0) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this Article !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(
            Config.apiUrl + "ArticleProduct/MultipleDelete?id[]=" + TotalIteam,
            {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(TotalIteam),
            }
          ).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                getData();
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Article  is safe!");
              }
            });
          });
        }
      });
    } else {
      swal("Sorry!", "pleace Select Articles.", "error");
    }
  };
  const SearchFilter = () => {
    setCurrentPageNo(1);
    getData();
  };

  const DeleteArticleDetails = (seleteArticleID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteArticleID != null &&
      seleteArticleID != "" &&
      seleteArticleID != undefined
    ) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this Article !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(Config.apiUrl + "ArticleProduct/Delete?id=" + seleteArticleID, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                getData();
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Article  is safe!");
              }
            });
          });
        }
      });
    }
  };
  const onChangeArticleSKU = (event) => {
    //setArticleSKUError('');
    setArticleSKU(event.target.value);
  };
  const handleColumnSort = (event) => {
    setCurrentPageNo(1);
    setcanPreviousPage(false);
    setcanNextPage(true);
    setSortColumn(event.selector);
    let SortType = "Desc";
    if (SortColumnType == "Desc") {
      SortType = "Asc";
    }
    setSortColumnType(SortType);
  };

  const toggleqr = (Qrcodepath) => {
    if (qrmodal === false) {
      if (Qrcodepath?.qrCodePath) {
        // setQrcodestring(Config.FrontUrl + Qrcodepath.qrCodePath);
        let qrcodestring = domainFrontUrl.current + Qrcodepath.qrCodePath;
        setQrcodestring(qrcodestring);
      }
      else {
        setQrcodestring("");
      }
      setQrcodeProductname(Qrcodepath.articleName);
    } else {
      setQrcodestring("");
      setQrcodeProductname("");
    }
    setqrmodal(!qrmodal);
  };
  const handleChange = async (state) => {
    setSelectedData(state.selectedRows);
  };

  const handlePerRowsChange = async (newRowsPerPage) => {
    if (!ArticlesVariationListTemp.length) return;
    setPerPage(newRowsPerPage);
    setLoading(true);
    let SkipRecord = 0;
    let data = [...ArticlesVariationListTemp];
    setCurrentPage(1);
    setRowsPerPage(newRowsPerPage);
    let tempdata = data.slice(SkipRecord, newRowsPerPage);
    setArticlesVariationList(tempdata);
    setLoading(false);
  };
  const handlePageChange = async (page) => {
    setLoading(true);

    setCurrentPage(page);
    let SkipRecord = 0;
    let data = [...ArticlesVariationListTemp];
    if (page > 1) {
      let SkipCount = page - 1;
      SkipRecord = rowsPerPage * SkipCount;
    }

    let tempdata = data.slice(SkipRecord, rowsPerPage);
    setArticlesVariationList(tempdata);
  };
  const handleMouseEnter = () => {
    action.fromUser = true;
  };

  const handleMouseLeave = () => {
    action.fromUser = false;
  };

  const columnsVariant = useMemo(
    () => [
      {
        name: "Sr. No",
        accessor: "variantsrnumber",
        selector: (row) => `${row.variantsrnumber}`,
        sortable: true,
        width: "6rem",
        // cell: (row, index) => {
        //   return <p>{row.sr}</p>;
        // },

        cell: (row, index) => {
          {
            console.log(
              "1396====>",
              (currentPage - 1) * rowsPerPage + (index + 1)
            );
            return (
              <p>
                {currentPage === 1
                  ? index + 1
                  : (currentPage - 1) * rowsPerPage + (index + 1)}
              </p>
            );
          }
        },
      },
      {
        name: "Image",
        accessor: "productimage",
        selector: "productimage",
        sortable: false,
        cell: (row) => {
          {
            let FullPath = `${Config.contentUrl + row.attributeImagePath}`;
            return row.attributeImagePath != null &&
              row.attributeImagePath != "" ? (
              <img
                src={FullPath}
                className="table-main-image btn-shadow"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = "../assets/img/new-images/images.png";
                }}
              ></img>
            ) : (
              <img
                src="../assets/img/new-images/images.png"
                style={{ height: "50px" }}
              ></img>
            );
          }
        },
      },
      {
        name: "Atribute",
        accessor: "attributeValue1",
        selector: (row) => `${row.attributeValue1}`,
        sortable: true,
        headerClassName: "rt-tr-align-right",
        cell: (row, index) => {
          if (
            row.attributeValue1 !== "" &&
            row.attributeValue2 !== "" &&
            row.attributeValue3 !== "" &&
            row.attributeValue4 !== "" &&
            row.attributeValue5 !== ""
          ) {
            return (
              <span>
                {row.attributeValue1 +
                  "/" +
                  row.attributeValue2 +
                  "/" +
                  row.attributeValue3 +
                  "/" +
                  row.attributeValue4 +
                  "/" +
                  row.attributeValue5}
              </span>
            );
          } else if (
            row.attributeValue1 !== "" &&
            row.attributeValue2 !== "" &&
            row.attributeValue3 !== "" &&
            row.attributeValue4 !== "" &&
            row.attributeValue5 === ""
          ) {
            return (
              <span>
                {row.attributeValue1 +
                  "/" +
                  row.attributeValue2 +
                  "/" +
                  row.attributeValue3 +
                  "/" +
                  row.attributeValue4}
              </span>
            );
          } else if (
            row.attributeValue1 !== "" &&
            row.attributeValue2 !== "" &&
            row.attributeValue3 !== "" &&
            row.attributeValue4 === "" &&
            row.attributeValue5 === ""
          ) {
            return (
              <span>
                {row.attributeValue1 +
                  "/" +
                  row.attributeValue2 +
                  "/" +
                  row.attributeValue3}
              </span>
            );
          } else if (
            row.attributeValue1 !== "" &&
            row.attributeValue2 !== "" &&
            row.attributeValue3 === "" &&
            row.attributeValue4 === "" &&
            row.attributeValue5 === ""
          ) {
            return (
              <span>{row.attributeValue1 + "/" + row.attributeValue2}</span>
            );
          } else if (
            row.attributeValue1 !== "" &&
            row.attributeValue2 === "" &&
            row.attributeValue3 === "" &&
            row.attributeValue4 === "" &&
            row.attributeValue5 === ""
          ) {
            return <span>{row.attributeValue1}</span>;
          } else {
            return <span>N / A</span>;
          }
        },
      },
      {
        name: "QR Code",
        accessor: "isPublished",
        selector: (row) => `${row.isPublished}`,
        sortable: true,
        cell: (row) => {

          return row.qrCode !== null &&
            row.qrCode !== "" &&
            row.qrCode !== undefined ? (
            <div>
              <button
                className={
                  "m-t-5 btn btn-white btn-shadow p-2 border " +
                  (row.isPublished === false ? "border-danger" : "")
                }
                onClick={() => {
                  toggleArticleVariant(row);
                }}
              >
                <img
                  src="../assets/img/user/QR.png"
                  alt="img"
                  style={{ height: "40px" }}
                  onerror="this.src='../assets/img/new-images/images.png';"
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>{row.isPublished === false ? "Pause" : "Play"}</b>
              </p>
            </div>
          ) : row.isshow == true ? (
            <div>
              <button
                className={
                  "m-t-5 btn btn-white btn-shadow p-2 border " +
                  (row.isPublished === false ? "border-danger" : "")
                }
                onClick={(e) => {
                  toggleQrCodeModal(row);
                }}
              >
                <img
                  src="/assets/img/new-Images/qr-code-scanner.jpg"
                  style={{ height: "40px", width: "40px" }}
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>{row.isPublished === false ? "Pause" : "Play"}</b>
              </p>
            </div>
          ) : (
            <div>
              <button
                className="m-t-5 btn btn-white btn-shadow p-2 border"
                onClick={(e) => {
                  swal("  Oops... not allowed ! ");
                }}
              >
                <img
                  src="../assets/img/new-Images/qr-code-scanner.jpg"
                  style={{ height: "40px", width: "40px" }}
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>{row.isPublished === false ? "Pause" : "Play"}</b>
              </p>
            </div>
          );
        },
      },
      {
        name: "scans",
        accessor: "totalScans",
        selector: (row) => `${row.totalScans}`,
        sortable: true,
        headerClassName: "rt-tr-align-right",
        cell: (row) => {
          {
            return row?.totalScans != null && row?.totalScans != "" ? (
              <div className="text-center">
                <p className="m-0">{row?.totalScans ? row?.totalScans : "0"}</p>
                {/* <button className='btn btn-link'>
                                    <img src="../assets/img/user/graph.png" style={{ height: '30px' }}></img>
                                </button > */}
              </div>
            ) : (
              <div className="text-center ">
                <p className="m-0">{0}</p>
                {/* <button className='btn btn-link'>
                                    <img src="../assets/img/user/graph.png" style={{ height: '30px' }}></img>
                                </button > */}
              </div>
            );
          }
        },
      },
      {
        name: " Created Date",
        accessor: "createdDate",
        selector: (row) => `${row.createdDate}`,
        sortable: true,
        cell: (row) => {
          let date = new Date(row.createdDate);
          let dateMDY = `${date.getDate()}-${date.getMonth() + 1
            }-${date.getFullYear()}`;
          return <span>{dateMDY}</span>;
        },
      },
      {
        name: " Actions",
        accessor: "col13",
        sortable: false,
        cell: (row) => {
          return (
            <div>
              {row.isshow == true ? (
                <UncontrolledButtonDropdown>
                  <DropdownToggle className="btn btn-success btn btn-warning ellipsis-btn">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </DropdownToggle>
                  {row?.qrCode !== null && row?.qrCode !== "" ? (
                    <DropdownMenu>
                      <DropdownItem
                        onClick={(e) => {
                          row?.isPublished === false
                            ? VariantPlay(row)
                            : VariantPlayAllready();
                        }}
                      >
                        <i className="fas fa-play m-r-10"></i>
                        Play
                      </DropdownItem>
                      <DropdownItem divider></DropdownItem>
                      <DropdownItem
                        onClick={(e) => {
                          row?.isPublished === false
                            ? VariantAllreadypush()
                            : VariantPause(row);
                        }}
                      >
                        <i className="fas fa-pause m-r-10"></i>
                        Pause
                      </DropdownItem>
                    </DropdownMenu>
                  ) : (
                    <DropdownMenu>
                      <DropdownItem
                        onClick={(e) => {
                          swal("Oops... Your Qrcode Not Generate ! ");
                        }}
                      >
                        <i className="fas fa-play m-r-10"></i>
                        Play
                      </DropdownItem>
                      <DropdownItem divider></DropdownItem>
                      <DropdownItem
                        onClick={(e) => {
                          swal("Oops... Your Qrcode Not Generate ! ");
                        }}
                      >
                        <i className="fas fa-pause m-r-10"></i>
                        Pause
                      </DropdownItem>
                    </DropdownMenu>
                  )}
                </UncontrolledButtonDropdown>
              ) : (
                <UncontrolledButtonDropdown>
                  <DropdownToggle className="btn btn-success btn btn-warning ellipsis-btn">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      onClick={(e) => {
                        swal("  Oops... not allowed ! ");
                      }}
                    >
                      <i className="fas fa-play m-r-10"></i>
                      Play
                    </DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem
                      onClick={(e) => {
                        swal("  Oops... not allowed ! ");
                      }}
                    >
                      <i className="fas fa-pause m-r-10"></i>
                      Pause
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              )}
            </div>
          );
        },
      },
    ],
    []
  );
  const columnsTotalQrcode = React.useMemo(
    () => [
      {
        name: "Sr. No.",
        accessor: "Qrcodenumber1",
        selector: "Qrcodenumber",
        minWidth: "7rem",
        sortable: false,
        cell: (row, index) => <p>{row.sr}</p>,
      },
      {
        name: "QR Code",
        accessor: "QR Code",
        selector: "QR Code",
        width: "6rem",
        sortable: false,
        cell: (row) => {
          console.log("row.isPublished", row.isPublished);
          return (
            <div>
              <button
                className={
                  "m-t-5 btn btn-white btn-shadow p-2 border border-width-1 " +
                  (row.isPublished === false ? "border-danger" : "")
                }
                onClick={() => {
                  toggleArticle(row);
                }}
              >
                <img
                  src="../assets/img/user/QR.png"
                  alt="img"
                  style={{ height: "40px", width: "40px" }}
                  onerror="this.src='../assets/img/new-images/images.png';"
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>{row.isPublished === false ? "Pause" : "Play"}</b>
              </p>
            </div>
          );
        },
      },
      {
        name: "Qty",
        accessor: "Qty",
        selector: "Qty",
        //width: "4rem",
        sortable: false,
        cell: (row) => {
          return (
            <p className="mb-0">
              {row?.bulkQrCodeQuantity ? `${row?.bulkQrCodeQuantity + 1}` : 1}
            </p>
          );
        },
      },
      {
        name: "Scans",
        accessor: "totalScans",
        selector: (row) => `${row.totalScans}`,
        sortable: true,
        // headerClassName: 'rt-tr-align-right',
        cell: (row) => {
          {
            return row?.totalScans != null && row?.totalScans != "" ? (
              <div className="text-center">
                <p className="m-0">{row?.totalScans ? row?.totalScans : "0"}</p>
                {/* <button className='btn btn-link'>
                                    <img src="../assets/img/user/graph.png" style={{ height: '30px' }}></img>
                                </button > */}
              </div>
            ) : (
              <div className="text-center ">
                <p className="m-0">{0}</p>
                {/* <button className='btn btn-link'>
                                    <img src="../assets/img/user/graph.png" style={{ height: '30px' }}></img>
                                </button > */}
              </div>
            );
          }
        },
      },

      {
        name: "Combination",
        accessor: "attributeName",
        selector: "attributeName",
        minWidth: "12rem",
        sortable: true,

        headerClassName: "rt-tr-align-right",
        cell: (row) => {
          {
            return row.isProductAttribute === true ? (
              <div className="tablerowitem">
                <p className="m-0">
                  {row?.productAttributeName
                    ? row?.productAttributeName
                    : "N/A"}
                </p>
              </div>
            ) : (
              <div className="tablerowitem">
                <p className="m-0">N/A</p>
              </div>
            );
          }
        },
      },
      {
        name: "Batch No.",
        accessor: "BatchNumber",
        selector: "BatchNumber",
        sortable: true,
        minWidth: "12rem",
        headerClassName: "rt-tr-align-right",
        cell: (row) => {
          {
            return (
              <div className="tablerowitem">
                <p className="m-0">
                  {row?.batchnumber ? row.batchnumber : "N/A"}
                </p>
              </div>
            );
          }
        },
      },
      {
        name: "Vendor",
        accessor: "Vendor Name",
        selector: "Vendor Name",
        sortable: true,
        minWidth: "12rem",
        headerClassName: "rt-tr-align-right",
        cell: (row) => {
          {
            if (
              row?.vendorId !== null &&
              row?.vendorId !== "" &&
              row?.vendorId !== undefined
            ) {
              return (
                <div className="tablerowitem">
                  <p className="m-0">
                    {row?.vendorName ? row.vendorName : "N/A"}
                  </p>
                </div>
              );
            } else {
              return <p className="m-0">N/A</p>;
            }
          }
        },
      },
      {
        name: "Manufacture date",
        accessor: "manufacturedate",
        selector: "manufacturedate",
        minWidth: "12rem",
        sortable: true,
        cell: (row) => {
          if (
            row.manufacturedate !== null &&
            row.manufacturedate !== "" &&
            row.manufacturedate !== undefined
          ) {
            let date = new Date(row.manufacturedate);
            let dateMDY = `${date.getDate()}-${date.getMonth() + 1
              }-${date.getFullYear()}`;

            return <span>{dateMDY}</span>;
          } else return <span>N/A</span>;
        },
      },
      {
        name: "Expiry date",
        accessor: "Expiry date",
        selector: "Expiry date",
        minWidth: "12rem",
        sortable: true,
        cell: (row) => {
          if (
            row.expirydate !== null &&
            row.expirydate !== "" &&
            row.expirydate !== undefined
          ) {
            let date = new Date(row.expirydate);
            let dateMDY = `${date.getDate()}-${date.getMonth() + 1
              }-${date.getFullYear()}`;

            return <span> {dateMDY}</span>;
          } else return <span>N/A</span>;
        },
      },
      {
        name: "Created Date",
        accessor: "createdDate",
        selector: "createdDate",
        minWidth: "12rem",
        sortable: true,
        cell: (row) => {
          let date = new Date(row.createdDate);
          let dateMDY = `${date.getDate()}-${date.getMonth() + 1
            }-${date.getFullYear()}`;
          return <span>{dateMDY}</span>;
        },
      },
      {
        name: "Actions",
        accessor: "col13",
        sortable: false,
        cell: (row) => {
          console.log("RowBulkQrCode===>", row);
          return (
            <div>
              {row.isshow == true ? (
                <UncontrolledButtonDropdown>
                  <DropdownToggle className="btn btn-success btn btn-warning ellipsis-btn">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      onClick={(e) => {
                        row?.isPublished === false
                          ? BulkPlay(row)
                          : BulkPlayAllready();
                      }}
                    >
                      <i className="fas fa-play m-r-10"></i>
                      Play
                    </DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem
                      onClick={(e) => {
                        row?.isPublished === false
                          ? BulkAllreadypush()
                          : BulkPause(row);
                      }}
                    >
                      <i className="fas fa-pause m-r-10"></i>
                      Pause
                    </DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem onClick={(e) => toggleQrcode(row)}>
                      <i className="fas fa-print m-r-10"></i>
                      Print more
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              ) : (
                <UncontrolledButtonDropdown>
                  <DropdownToggle className="btn btn-success btn btn-warning ellipsis-btn">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      onClick={(e) => {
                        swal("  Oops... not allowed ! ");
                      }}
                    >
                      <i className="fas fa-play m-r-10"></i>
                      Play
                    </DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem
                      onClick={(e) => {
                        swal("  Oops... not allowed ! ");
                      }}
                    >
                      <i className="fas fa-pause m-r-10"></i>
                      Pause
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  const toggleArticle = (Qrcodepath) => {
    console.log("Qrcodepath==>", Qrcodepath)
    // setTotalQrcodeModel(false)
    if (modalArticleQroce === false) {

      if (Qrcodepath?.codeString) {
        let qrcodestring = domainFrontUrl.current + Qrcodepath.codeString;
        setQrcodestring(qrcodestring);

        // setQrcodestring(Config.FrontUrl + Qrcodepath.codeString);
      } else {
        setQrcodestring(domainFrontUrl.current);
        // setQrcodestring(Config.FrontUrl);
      }
      setQrcodeProductname(Qrcodepath.productName);
    } else {
      if (TotalQrcodeModel === true) {
        setTotalQrcodeModel(true);
      }
      setQrcodestring("");
      setQrcodeProductname("");
    }
    setmodalArticleQroce(!modalArticleQroce);
  };

  const toggleQrCodeModal = (row) => {
    if (
      row?.articleID !== null &&
      row?.articleID !== undefined &&
      row?.articleID !== ""
    ) {
      setArticleId(row?.articleID);
      setQrCodeString("");
      setQrCodeModalisOpen(!QrCodeModalisOpen);
      setselectCombinationID(row?._id);
      if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 !== "" &&
        row.attributeValue3 !== "" &&
        row.attributeValue4 !== "" &&
        row.attributeValue5 !== ""
      ) {
        setselectCombination(
          row.attributeValue1 +
          "/" +
          row.attributeValue2 +
          "/" +
          row.attributeValue3 +
          "/" +
          row.attributeValue4 +
          "/" +
          row.attributeValue5
        );
      } else if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 !== "" &&
        row.attributeValue3 !== "" &&
        row.attributeValue4 !== "" &&
        row.attributeValue5 === ""
      ) {
        setselectCombination(
          row.attributeValue1 +
          "/" +
          row.attributeValue2 +
          "/" +
          row.attributeValue3 +
          "/" +
          row.attributeValue4
        );
      } else if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 !== "" &&
        row.attributeValue3 !== "" &&
        row.attributeValue4 === "" &&
        row.attributeValue5 === ""
      ) {
        setselectCombination(
          row.attributeValue1 +
          "/" +
          row.attributeValue2 +
          "/" +
          row.attributeValue3
        );
      } else if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 !== "" &&
        row.attributeValue3 === "" &&
        row.attributeValue4 === "" &&
        row.attributeValue5 === ""
      ) {
        setselectCombination(row.attributeValue1 + "/" + row.attributeValue2);
      } else if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 === "" &&
        row.attributeValue3 === "" &&
        row.attributeValue4 === "" &&
        row.attributeValue5 === ""
      ) {
        setselectCombination(row.attributeValue1);
      } else {
        setselectCombination("N/A");
      }
    } else {
      setQrCodeModalisOpen(false);
      setQrCodeString("");
    }
  };

  const toggleArticleVariant = (row) => {
    if (modalArticleQroce === false) {
      let attribute = "";
      if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 !== "" &&
        row.attributeValue3 !== "" &&
        row.attributeValue4 !== "" &&
        row.attributeValue5 !== ""
      ) {
        attribute =
          row.attributeValue1 +
          "/" +
          row.attributeValue2 +
          "/" +
          row.attributeValue3 +
          "/" +
          row.attributeValue4 +
          "/" +
          row.attributeValue5;
      } else if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 !== "" &&
        row.attributeValue3 !== "" &&
        row.attributeValue4 !== "" &&
        row.attributeValue5 === ""
      ) {
        attribute =
          row.attributeValue1 +
          "/" +
          row.attributeValue2 +
          "/" +
          row.attributeValue3 +
          "/" +
          row.attributeValue4;
      } else if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 !== "" &&
        row.attributeValue3 !== "" &&
        row.attributeValue4 === "" &&
        row.attributeValue5 === ""
      ) {
        attribute =
          row.attributeValue1 +
          "/" +
          row.attributeValue2 +
          "/" +
          row.attributeValue3;
      } else if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 !== "" &&
        row.attributeValue3 === "" &&
        row.attributeValue4 === "" &&
        row.attributeValue5 === ""
      ) {
        attribute = row.attributeValue1 + "/" + row.attributeValue2;
      } else if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 === "" &&
        row.attributeValue3 === "" &&
        row.attributeValue4 === "" &&
        row.attributeValue5 === ""
      ) {
        attribute = row.attributeValue1;
      }
      if (row?.qrCode) {
        let qrcodestring = domainFrontUrl.current + row.qrCode;
        setQrcodestring(qrcodestring);
        // setQrcodestring(Config.FrontUrl + row.qrCode);
      }
      else {
        setQrcodestring("");
      }

      setQrcodeProductname(attribute);
    } else {
      setQrcodestring("");
      setQrcodeProductname("");
    }
    setmodalArticleQroce(!modalArticleQroce);
  };
  const downloadQRCodeArticle = () => {
    // const qrCodeURL = document.getElementById('qrCodeEl')
    //     .toDataURL("image/png")
    //     .replace("image/png", "image/octet-stream");
    // var doc = new jsPDF("p", "pt", "c6");
    // doc.setFontSize(22);
    // doc.text(20, 30, "Qr Code");
    // doc.setFontSize(10);
    // // doc.text(20, 80, "Title: " + row.title);
    // // doc.text(20, 100, "Years: " + row.years);
    // doc.addImage(qrCodeURL, "JPEG", 100, 100, 150, 200);
    // doc.save("QrCode.pdf");
    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL);
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  const printQrcode = () => {
    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    var doc = new jsPDF("p", "pt", "A4");
    doc.setFontSize(22);
    doc.text(20, 30, QrcodeProductname);
    doc.setFontSize(10);
    // doc.text(20, 80, "Title: " + row.title);
    // doc.text(20, 100, "Years: " + row.years);
    doc.addImage(qrCodeURL, "JPEG", 100, 100, 200, 200);
    //doc.save("QrCode.pdf");
    doc.autoPrint();
    doc.output("dataurlnewwindow");
  };
  const printQrcodeBulk = () => {
    const qrCodeURL = document
      .getElementById("qrCodeElBulk")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    var doc = new jsPDF("p", "pt", "A4");
    doc.setFontSize(22);
    doc.text(20, 30, QrcodeProductname);
    doc.setFontSize(10);
    // doc.text(20, 80, "Title: " + row.title);
    // doc.text(20, 100, "Years: " + row.years);
    doc.addImage(qrCodeURL, "JPEG", 100, 100, 200, 200);
    //doc.save("QrCode.pdf");
    doc.autoPrint();
    doc.output("dataurlnewwindow");
  };
  const downloadQRCodeBulk = () => {
    // const qrCodeURL = document.getElementById('qrCodeEl')
    //     .toDataURL("image/png")
    //     .replace("image/png", "image/octet-stream");
    // var doc = new jsPDF("p", "pt", "c6");
    // doc.setFontSize(22);
    // doc.text(20, 30, "Qr Code");
    // doc.setFontSize(10);
    // // doc.text(20, 80, "Title: " + row.title);
    // // doc.text(20, 100, "Years: " + row.years);
    // doc.addImage(qrCodeURL, "JPEG", 100, 100, 150, 200);
    // doc.save("QrCode.pdf");
    const qrCodeURL = document
      .getElementById("qrCodeElBulk")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL);
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  const printQrcodeAttributecreate = () => {
    const qrCodeURL = document
      .getElementById("qrCodeElAttributecreate")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    var doc = new jsPDF("p", "pt", "A4");
    doc.setFontSize(22);
    doc.text(20, 30, QrcodeProductname);
    doc.setFontSize(10);
    // doc.text(20, 80, "Title: " + row.title);
    // doc.text(20, 100, "Years: " + row.years);
    doc.addImage(qrCodeURL, "JPEG", 100, 100, 200, 200);
    //doc.save("QrCode.pdf");
    doc.autoPrint();
    doc.output("dataurlnewwindow");
  };

  const getDataArticleVariation = (ArticleProductID) => {
    setLoading(true);
    //let ArticleProductID = "62020eba621486d663fd5f9a";
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");

    fetch(
      Config.apiUrl +
      "ArticleProduct/GetProductAllvariation?id=" +
      ArticleProductID,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result !== null) {
          setArticlesNo(result.articleNumber);
          setArticlesName(result.articleName);
          if (result.categorydetail != null && result.categorydetail != "") {
            setArticlescategoryName(result.categorydetail.name);
            setArticlessubcategoryName(result.subcategorydetail.name);
          }
          setTotalCount(result.totalCount);
          setArticlesVariationList(
            result.attributeValueMappingList?.slice(0, 10)
          );
          setArticlesVariationListTemp(result.attributeValueMappingList);
          let FullPath = `${Config.contentUrl + result.productImage}`;
          setArticlesProfileImage(FullPath);
          setvariationlistmodal(true);
          setTotalRows(result.attributeValueMappingList?.length);
          // totalRowsref.current = result.attributeValueMappingList?.length
          //   ? result.attributeValueMappingList?.length
          //   : 0;
        } else {
          setArticlesVariationList([]);
        }
        setLoading(false);
      });
      setLoading(false);
    });
    setLoading(false);
  };

  const ProductVariations = (ArticleProductID) => {
    if (
      ArticleProductID != null &&
      ArticleProductID != "" &&
      ArticleProductID != undefined
    ) {
      if (variationlistmodal === false) {
        getDataArticleVariation(ArticleProductID);
      }

      setvariationlistmodal(false);
    } else {
      setvariationlistmodal(false);
    }
  };
  const Exportvariations = () => {
    let loginid = localStorage.getItem("loginUserID");

    let Auth0token = localStorage.getItem("Auth0token");
    let TotalIteam = [];
    for (let index = 0; index < selectedData.length; index++) {
      TotalIteam.push(selectedData[index]._id);
    }
    if (TotalIteam.length > 0) {
      fetch(Config.apiUrl + "AttributeValueMap/Export", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(TotalIteam),
      })
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = "ExportVariation.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
    } else {
      swal("Sorry!", "pleace Select Variation.", "error");
    }
  };
  const AddArticleDetails = (ArticleIdObj) => {
    // history.push({
    //   pathname: "/qrcodemanagement/product-addnew",
    //   state: { EditArticleDetailsID: ArticleIdObj },
    // });
    history.push({
      pathname: "/product-addnew",
      state: { EditArticleDetailsID: ArticleIdObj },
    });
  };
  const gotoreports = (ProductId) => {
    // history.push({
    //   pathname: "/dashboard/reports",
    //   state: { ActivePill: "2", ProductID: ProductId },
    // });
    history.push({
      pathname: "/reports",
      state: { ActivePill: "2", ProductID: ProductId },
    });
  };
  const ArticlePlayAllreadyplay = () => {
    swal("Your Product already Play !");
  };
  const ArticlePlayAllreadypush = () => {
    swal("Your Product already push !");
  };
  const ArticlePlay = (seleteArticleID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteArticleID != null &&
      seleteArticleID != "" &&
      seleteArticleID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdateArticlePublish?id=" +
        seleteArticleID +
        "&isPublish=" +
        true,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            getData();
            swal("Congratulations! Your Article is Publish successfully.", {
              icon: "success",
            });
          } else {
            swal("Your Article not Publish successfully.!");
          }
        });
      });
    }
  };

  const ArticlePause = (seleteArticleID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteArticleID != null &&
      seleteArticleID != "" &&
      seleteArticleID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdateArticlePublish?id=" +
        seleteArticleID +
        "&isPublish=" +
        false,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            getData();
            swal("Congratulations! Your Article is Pause successfully.", {
              icon: "success",
            });
          } else {
            swal("Your Article not Pause successfully.!");
          }
        });
      });
    }
  };

  const VariantPlayAllready = () => {
    swal("Your Variant already play !");
  };
  const VariantAllreadypush = () => {
    swal("Your Variant already pushed !");
  };
  const VariantPlay = (item) => {
    let seleteVariantID = item?._id;
    let articleID = item?.articleID;
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteVariantID != null &&
      seleteVariantID != "" &&
      seleteVariantID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "AttributeValueMap/UpdateIsPublish?id=" +
        seleteVariantID +
        "&isPublish=" +
        true,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            getDataArticleVariation(articleID);
            swal("Congratulations! Your Article is Play successfully.", {
              icon: "success",
            });
          } else {
            swal("Your Article not Play successfully.!");
          }
        });
      });
    }
  };
  const VariantPause = (item) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let seleteVariantID = item?._id;
    let articleID = item?.articleID;
    if (
      seleteVariantID != null &&
      seleteVariantID != "" &&
      seleteVariantID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "AttributeValueMap/UpdateIsPublish?id=" +
        seleteVariantID +
        "&isPublish=" +
        false,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            getDataArticleVariation(articleID);
            swal("Congratulations! Your Article is Pause successfully.", {
              icon: "success",
            });
          } else {
            swal("Your Article not Pause successfully.!");
          }
        });
      });
    }
  };
  const BulkPlayAllready = () => {
    swal("Your Variant already Play !");
  };
  const BulkAllreadypush = () => {
    swal("Your Variant already push !");
  };
  const BulkPlay = (item) => {
    let seleteVariantID = item?._id;
    let articleID = item?.mainTargetID;
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteVariantID != null &&
      seleteVariantID != "" &&
      seleteVariantID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/UpdatePublish?id=" +
        seleteVariantID +
        "&isPublish=" +
        true,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            if (
              (item?.batchnumber == null ||
                item?.batchnumber === "" ||
                item?.batchnumber === undefined) &&
              (item?.manufacturedate === null ||
                item?.manufacturedate === "" ||
                item?.manufacturedate === undefined) &&
              (item?.vendorId === null ||
                item?.vendorId === "" ||
                item?.vendorId === undefined)
            ) {
              getData();
            }
            getBulkQrCodeData(articleID);
            swal("Congratulations! Your Article is Play successfully.", {
              icon: "success",
            });
          } else {
            swal("Your Article not Play successfully.!");
          }
        });
      });
    }
  };
  const BulkPause = (item) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let seleteVariantID = item?._id;
    let articleID = item?.mainTargetID;
    if (
      seleteVariantID != null &&
      seleteVariantID != "" &&
      seleteVariantID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/UpdatePublish?id=" +
        seleteVariantID +
        "&isPublish=" +
        false,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            if (
              (item?.batchnumber == null ||
                item?.batchnumber === "" ||
                item?.batchnumber === undefined) &&
              (item?.manufacturedate === null ||
                item?.manufacturedate === "" ||
                item?.manufacturedate === undefined) &&
              (item?.vendorId === null ||
                item?.vendorId === "" ||
                item?.vendorId === undefined)
            ) {
              getData();
            }
            getBulkQrCodeData(articleID);
            swal("Congratulations! Your Article is Pause successfully.", {
              icon: "success",
            });
          } else {
            swal("Your Article not Pause successfully.!");
          }
        });
      });
    }
  };
  const onChangePublished = (event) => {
    console.log(event.target.value);
    setIsPublished(event.target.value);
  };

  const QrcodeCombinationalredycreate = () => {
    swal("Combination QR code, has been already generated");
  };
  const getqrcodeAttributes = (CombinationID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      CombinationID !== null &&
      CombinationID !== "" &&
      CombinationID !== undefined
    ) {
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/GetQrcodestring?targetId=" +
        CombinationID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          //Do something with the response
          console.log("responseJson=>", responseJson);
          if (responseJson !== null && responseJson !== "") {
            if (responseJson?.codeString) {
              let qrcodestring = domainFrontUrl.current + responseJson.codeString;
              setQrCodeString(qrcodestring);
              // setQrCodeString(Config.FrontUrl + responseJson.codeString);
            }
            else {
              setQrCodeString("");
            }
            getDataArticleVariation(ArticleId);
          } else {
            setQrCodeString("");
          }
        })
        .catch((error) => {
          console.log(error);
          setQrCodeString("");
        });
    } else {
      setQrCodeString("");
    }
    //
  };

  const getqrcodeAttributesNew = async (ProductID) => {
    if (ProductID !== null && ProductID !== "" && ProductID !== undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      let ManufactureDateFinalTemp = "";
      if (ManufactureDate !== null) {
        // ManufactureDateFinalTemp = ManufactureDateFinal;
        ManufactureDateFinalTemp = Moment(ManufactureDate).format("YYYY-MM-DD");
      }
      let ExpiryDateFinalTemp = "";
      if (ExpiryDate !== null) {
        ExpiryDateFinalTemp = Moment(ExpiryDate).format("YYYY-MM-DD");
      }
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/GetQrcodestringfilter?targetId=" +
        selectCombinationNewID +
        "&BatchNumber=" +
        selectBatchNumbername +
        "&ManufactureDate=" +
        ManufactureDateFinalTemp +
        "&VendorsID=" +
        VendorID +
        "&productID=" +
        ProductID +
        "&Expirydate=" +
        ExpiryDateFinalTemp,

        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          if (
            responseJson !== null &&
            responseJson?._id !== "" &&
            responseJson?._id !== null &&
            responseJson?._id !== undefined
          ) {
            setQrCodeqrcodeIDnew(responseJson?._id);
            if (responseJson?.codeString) {
              let qrcodestring = domainFrontUrl.current + responseJson.codeString;
              // // setQrCodeStringnew(Config.FrontUrl + responseJson?.codeString);
              setQrCodeStringnew(qrcodestring);
            }
            else {
              setQrCodeStringnew("");
            }
            setQrcodeQty(0);
            setDuplicateQrcodeList("");
          } else {
            setQrCodeqrcodeIDnew("");
            setQrCodeStringnew("");
            setQrcodeQty(0);
            setDuplicateQrcodeList("");
          }
        })
        .catch((error) => {
          console.log(error);
          setQrCodeqrcodeIDnew("");
          setQrCodeStringnew("");
          setQrcodeQty(0);
          setDuplicateQrcodeList("");
        });
    }
    //
  };

  const Qrcodegenerator = () => {
    // let url = Config.FrontUrl + 'productdetails?mapId=' + selectCombinationID + '&render=Combination';
    if (
      QrCodeStringnew === null ||
      QrCodeStringnew === "" ||
      QrCodeStringnew === undefined
    ) {
      if (
        selectCombinationID !== null &&
        selectCombinationID !== "" &&
        selectCombinationID !== undefined
      ) {
        let loginid = localStorage.getItem("loginUserID");
        let Auth0token = localStorage.getItem("Auth0token");

        let ArticleQrcodestring = {
          UserCompanyID: loginid,
          // TargetType: "ProductQrCodeAttributes",
          TargetType: "ProductQrCodeAttributes",
          TargetID: selectCombinationID,
          // CodeString: url,
          IsDeleted: false,
          // BatchNumber: BatchNumber,
          BatchNumber: selectBatchNumbername,
          EnableEWarranty: EnableEWarranty,
          // Expirydate: ExpiryDate ? new Date(ExpiryDate) : null,
          // Manufacturedate: ManufactureDate ? new Date(ManufactureDate) : null,
          //Manufacturedatestring:ManufactureDate ? ManufactureDate : null,
          Expirydate: ExpiryDate
            ? Moment(ExpiryDate).format("YYYY-MM-DD")
            : null,
          Manufacturedate: ManufactureDate
            ? Moment(ManufactureDate).format("YYYY-MM-DD")
            : null,
          Manufacturedatestring: ManufactureDate
            ? Moment(ManufactureDate).format("YYYY-MM-DD")
            : null,

          VendorId: VendorID,
          MainTargetID: newqrcodeid,
          CombinationId: selectCombinationID,
        };
        fetch(
          Config.apiUrl + "QrCodeResourceController/CreateQrcodestringproduct",
          {
            headers: {
              userCompanyID: loginid,
              "Content-Type": "application/json",
              Authorization: "Bearer " + Auth0token,
            },
            method: "POST",
            body: JSON.stringify(ArticleQrcodestring),
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .then((responseJson) => {
            if (responseJson !== null && responseJson !== "") {
              if (responseJson?._id !== null) {
                getData();
                setQrcodeQty(0);
                setQrCodeqrcodeIDnew(responseJson?._id);
                if (responseJson?.codeString) {
                  let qrcodestring = domainFrontUrl.current + responseJson.codeString;
                  // setQrCodeStringnew(Config.FrontUrl + responseJson?.codeString);
                  setQrCodeStringnew(qrcodestring);
                }
                swal("successfully", "Product  Qrcode generate.", "success");
              } else {
                swal("error", "Product  Qrcode not generate.", "error");
              }
            } else {
              setQrCodeqrcodeIDnew("");
              setQrCodeStringnew("");
              setQrcodeQty(0);
              swal("error", "Product  Qrcode not generate.", "error");
            }
          })
          .catch((error) => {
            swal("error", error?.message, "error");
            console.log(error);
            setQrCodeStringnew("");
            setQrCodeqrcodeIDnew("");
          });
      } else {
        swal("oops!", "please select Combination ", "warning");
      }
    } else {
      swal("Qr code already created");
    }
  };
  const QrcodegeneratorArticle = () => {
    if (
      QrCodeStringnew === null ||
      QrCodeStringnew === "" ||
      QrCodeStringnew === undefined
    ) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      let ArticleQrcodestring = {
        UserCompanyID: loginid,
        TargetType: "ProductQrCode",
        TargetID: newqrcodeid,
        // CodeString: url,
        IsDeleted: false,
        BatchNumber: selectBatchNumbername,
        EnableEWarranty: EnableEWarranty,
        Expirydate: ExpiryDate ? Moment(ExpiryDate).format("YYYY-MM-DD") : null,
        Manufacturedate: ManufactureDate
          ? Moment(ManufactureDate).format("YYYY-MM-DD")
          : null,
        Manufacturedatestring: ManufactureDate
          ? Moment(ManufactureDate).format("YYYY-MM-DD")
          : null,
        MainTargetID: newqrcodeid,
        CombinationId: "",
        VendorId: VendorID,
      };
      fetch(
        Config.apiUrl + "QrCodeResourceController/CreateQrcodestringproduct",
        {
          headers: {
            userCompanyID: loginid,
            "Content-Type": "application/json",
            Authorization: "Bearer " + Auth0token,
          },
          method: "POST",
          body: JSON.stringify(ArticleQrcodestring),
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          if (responseJson?._id !== null && responseJson?._id !== "") {
            getData();
            if (responseJson?.codeString) {
              let qrcodestring = domainFrontUrl.current + responseJson.codeString;
              // setQrCodeStringArticle(Config.FrontUrl + responseJson.codeString);
              // setQrCodeStringnew(Config.FrontUrl + responseJson.codeString);
              setQrCodeStringArticle(qrcodestring);
              setQrCodeStringnew(qrcodestring);
            }
            setQrCodeqrcodeIDnew(responseJson?._id);
            swal("successfully", "Product  Qrcode created.", "success");
          } else {
            setQrCodeqrcodeIDnew("");
            setQrCodeStringArticle("");
            swal("error", "Product  Qrcode not generate.", "error");
          }
        })
        .catch((error) => {
          console.log(error);
          swal("error", error.message, "error");
          setQrCodeID("");
          setQrCodeStringArticle("");
        });
    } else {
      swal("Qr code already created");
    }
  };

  const QrcodegeneratorVariations = () => {
    // let url = Config.FrontUrl + 'productdetails?mapId=' + selectCombinationID + '&render=Combination';
    if (
      QrCodeString === null ||
      QrCodeString === "" ||
      QrCodeString === undefined
    ) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");

      let ArticleQrcodestring = {
        UserCompanyID: loginid,
        TargetType: "ProductQrCodeAttributes",
        TargetID: selectCombinationID,
        IsDeleted: false,
        BatchNumber: "",
        EnableEWarranty: EnableEWarranty,
        Expirydate: null,
        Manufacturedate: null,
        Manufacturedatestring: null,
        VendorId: "",
        MainTargetID: ArticleId,
        CombinationId: selectCombinationID,
      };
      console.log("ArticleQrcodestring ==", ArticleQrcodestring);
      fetch(
        Config.apiUrl + "QrCodeResourceController/CreateQrcodestringproduct",
        {
          headers: {
            userCompanyID: loginid,
            "Content-Type": "application/json",
            Authorization: "Bearer " + Auth0token,
          },
          method: "POST",
          body: JSON.stringify(ArticleQrcodestring),
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          if (responseJson !== null && responseJson !== "") {
            if (responseJson?._id !== null) {
              getData();
              getqrcodeAttributes(selectCombinationID);
              if (responseJson?.codeString) {
                let qrcodestring = domainFrontUrl.current + responseJson.codeString;
                // setQrCodeString(Config.FrontUrl + responseJson?.codeString);
                setQrCodeString(qrcodestring);
              }
              else {
                setQrCodeString("");
              }
              swal("successfully", "Product  Qrcode generate.", "success");
            } else {
              swal("error", "Product  Qrcode not generate.", "error");
            }
          } else {
            setQrCodeString("");
            swal("error", "Product  Qrcode not generate.", "error");
          }
        })
        .catch((error) => {
          swal(error, "error");
          console.log(error);
          setQrCodeString("");
        });
    } else {
      swal("Qr code already created");
    }
  };

  const downloadQRCode = () => {
    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL);
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  const downloadQRCodeAttributecreate = () => {
    const qrCodeURL = document
      .getElementById("qrCodeElAttributecreate")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL);
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  const toggleToEmailBulk = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisToEamilBulk(!isToEamilBulk);
  };
  const toggleToEmail = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisToEamil(!isToEamil);
  };
  const toggleToEmailAttributecreate = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisToEamilAttribute(!isToEamilAttribute);
  };
  const SubToEmailremoveClick = (i) => {
    setToemailEmptyError("");
    setisToemailMaltiple(false);
    let subToEmailTemp = [...subToEmail];
    if (subToEmailTemp != null && subToEmailTemp !== undefined) {
      subToEmailTemp.splice(i, 1);
    }
    setsubToEmail(subToEmailTemp);
  };
  const SubToEmailhandleChange = (i) => (event) => {
    setToemailEmptyError("");
    setisToemailMaltiple(false);
    let subToemaillistnewTemp = [...subToEmail];
    subToemaillistnewTemp[i] = event.target.value;
    setsubToEmail(subToemaillistnewTemp);
    const unique = [...new Set(subToemaillistnewTemp)];
    if (subToemaillistnewTemp.length !== unique.length) {
      setisToemailMaltiple(true);
    }
  };
  const SubToEmailaddClick = () => {
    setsubToEmail((n) => [...n, ""]);
  };

  const createSubToEmailUI = () => {
    return subToEmail.map((el, i) => (
      <div key={i} className="removeSection">
        <input
          type="text"
          className="form-control mr-2"
          // maxlength="50"
          placeholder="Enter To Email"
          value={el || ""}
          onChange={SubToEmailhandleChange(i)}
        />
        {i > 0 ? (
          <a
            href="javascript:void(0)"
            onClick={(e) => {
              SubToEmailremoveClick(i);
            }}
            className="btn btn-danger"
          >
            <i class="fas fa-trash"></i>
          </a>
        ) : (
          <></>
        )}
      </div>
    ));
  };

  const QRCodeArticleSend = async (e) => {
    const unique = [...new Set(subToEmail)];
    if (subToEmail.length !== unique.length) {
      setisToemailMaltiple(true);
      return;
    }
    const found = subToEmail.find(
      (element) => element === "" || element === "" || element === null
    );
    if (found != undefined) {
      setToemailEmptyError("All filled is required");
      return;
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    const qrCodeURL = await document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let filelist = [];
    let filedata = {
      path: "png",
      sourceURL: "png",
      data: qrCodeURL,
    };
    filelist.push(filedata);
    let ContactHelpModel = {
      UserCompanyID: loginid,
      name: ".png",
      // "To": "rprajapati@eagletechsolutions.uk",
      subject: "Qrcode",
      body: QrcodeProductname,
      attachFileList: filelist,
      ToEmailList: subToEmail,
    };
    fetch(Config.apiUrl + "EmailQueue/SendMailOfQrcodesend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(ContactHelpModel),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        console.log("123=====>", resp1);
        if (resp1 === true) {
          toggleToEmail();
          swal("Thank You", "Successfully  send email", "success");
        } else {
          swal("Sorry", "Pleace  Contact Admin.", "error");
        }
      });
  };
  const QRCodeArticleSendAttributecreate = async (e) => {
    const unique = [...new Set(subToEmail)];
    if (subToEmail.length !== unique.length) {
      setisToemailMaltiple(true);
      return;
    }

    const found = subToEmail.find(
      (element) => element === "" || element === "" || element === null
    );
    if (found != undefined) {
      setToemailEmptyError("All filled is required");
      return;
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    const qrCodeURL = await document
      .getElementById("qrCodeElAttributecreate")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let filelist = [];
    let filedata = {
      path: "png",
      sourceURL: "png",
      data: qrCodeURL,
    };
    filelist.push(filedata);
    // let Toemail = [];
    // Toemail.push("rprajapati@eagletechsolutions.uk")

    let ContactHelpModel = {
      UserCompanyID: loginid,
      name: ".png",
      // "To": "rprajapati@eagletechsolutions.uk",
      subject: "Qrcode",
      body: selectCombination,
      attachFileList: filelist,
      ToEmailList: subToEmail,
    };
    fetch(Config.apiUrl + "EmailQueue/SendMailOfQrcodesend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(ContactHelpModel),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        console.log("123=====>", resp1);
        if (resp1 === true) {
          toggleToEmailAttributecreate();
          swal("Thank You", "Successfully  send email", "success");
        } else {
          swal("Sorry", "Pleace  Contact Admin.", "error");
        }
      });
  };

  const QRCodeArticleSendBulk = async (e) => {
    const unique = [...new Set(subToEmail)];
    if (subToEmail.length !== unique.length) {
      setisToemailMaltiple(true);
      return;
    }
    const found = subToEmail.find(
      (element) => element === "" || element === "" || element === null
    );
    if (found != undefined) {
      setToemailEmptyError("All filled is required");
      return;
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    const qrCodeURL = await document
      .getElementById("qrCodeElBulk")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let filelist = [];
    let filedata = {
      path: "png",
      sourceURL: "png",
      data: qrCodeURL,
    };
    filelist.push(filedata);
    let ContactHelpModel = {
      UserCompanyID: loginid,
      name: ".png",
      subject: "Qrcode",
      body: QrcodeProductname,
      attachFileList: filelist,
      ToEmailList: subToEmail,
    };
    fetch(Config.apiUrl + "EmailQueue/SendMailOfQrcodesend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(ContactHelpModel),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        console.log("123=====>", resp1);
        if (resp1 === true) {
          toggleToEmailBulk();
          swal("Thank You", "Successfully  send email", "success");
        } else {
          swal("Sorry", "Pleace  Contact Admin.", "error");
        }
      });
  };
  const OnchangedQrCodeQty = (e) => {
    setQrcodeQty(e.target.value);
  };

  const DuplicateQrcodeCreate = () => {
    if (
      QrcodeQty > 0 &&
      QrCodeID !== null &&
      QrCodeID !== undefined &&
      QrCodeID !== ""
    ) {
      let UserCompanyId = localStorage.getItem("UserCompanyId");
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(
        Config.apiUrl +

        "QrCodeResourceController/UpdateQrCodeResourceBulkQrCodeQuantity?id=" +
        QrCodeID +
        "&bulkQrCodeQuantity=" +
        QrcodeQty +
        "&userCompanyID=" +
        UserCompanyId,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          getBulkQrCodeData(selectproductid);
          if (
            QrCodeString !== "" &&
            QrCodeString !== undefined &&
            QrCodeString !== null
          ) {
            let Qrcodestringtemp = [];
            for (let index = 0; index < Math.ceil(QrcodeQty); index++) {
              Qrcodestringtemp.push(QrCodeString);
            }
            setDuplicateQrcodeList(Qrcodestringtemp);
          } else {
            swal("Sorry!", "pleace create Qrcode", "error");
          }
        });
      });
    }
  };

  const DuplicateQrcodeCreateNew = () => {
    if (
      QrcodeQty > 0 &&
      QrCodeqrcodeIDnew !== null &&
      QrCodeqrcodeIDnew !== undefined &&
      QrCodeqrcodeIDnew !== ""
    ) {
      let UserCompanyId = localStorage.getItem("UserCompanyId");
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/UpdateQrCodeResourceBulkQrCodeQuantity?id=" +
        QrCodeqrcodeIDnew +
        "&bulkQrCodeQuantity=" +
        QrcodeQty +
        "&userCompanyID=" +
        UserCompanyId,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => { });
      });
      if (
        selectCombinationID != "" &&
        selectCombinationID != undefined &&
        selectCombinationID != null
      ) {
        if (
          QrCodeStringnew !== "" &&
          QrCodeStringnew !== undefined &&
          QrCodeStringnew !== null
        ) {
          let Qrcodestringtemp = [];
          for (let index = 0; index < Math.ceil(QrcodeQty); index++) {
            Qrcodestringtemp.push(QrCodeStringnew);
          }
          setDuplicateQrcodeList(Qrcodestringtemp);
        } else {
          swal("Sorry!", "pleace create Qrcode", "error");
        }
      } else {
        if (
          QrCodeStringnew !== "" &&
          QrCodeStringnew !== undefined &&
          QrCodeStringnew !== null
        ) {
          let Qrcodestringtemp = [];
          for (let index = 0; index < Math.ceil(QrcodeQty); index++) {
            Qrcodestringtemp.push(QrCodeStringnew);
          }
          setDuplicateQrcodeList(Qrcodestringtemp);
        } else {
          swal("Sorry!", "pleace create Qrcode", "error");
        }
      }
    }
  };
  const downloadQRDuplicate = () => {
    if (DuplicateQrcodeList.length > 0) {
      let totalqrcodePDf = [];
      for (let index = 0; index < DuplicateQrcodeList.length; index++) {
        const element = DuplicateQrcodeList[index];
        const qrCodeURL = document
          .getElementById("qrCodeElDuplicate" + index)
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        totalqrcodePDf.push(qrCodeURL);
      }

      var doc = new jsPDF();
      doc.text(20, 30, ArticleName);
      let noofpage = Math.ceil(totalqrcodePDf.length / 12);
      let pagenum = 1;
      let rownumber = 1;
      let posisionnumber = 1;
      doc.text(20, 10, ArticleName);
      for (let index = 0; index < totalqrcodePDf.length; index++) {
        const element = totalqrcodePDf[index];
        if (rownumber === 1) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 20, 50, 50, "FD");

            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 20, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 20, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 2;
          }
        } else if (rownumber === 2) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 80, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 80, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 80, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 3;
          }
        } else if (rownumber === 3) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 140, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 140, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 140, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 4;
          }
        } else if (rownumber === 4) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 200, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 200, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 200, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 1;
            if (pagenum < noofpage) {
              doc.addPage();
              pagenum = pagenum + 1;
            }
          }
        }
      }
      // doc.output('dataurlnewwindow');
      doc.save("QrCode" + new Date().getTime() + ".pdf");

      // var doc = new jsPDF("p", "pt", "A4");
      // doc.setFontSize(22);
      // doc.text(20, 30, ArticleName);
      // doc.setFontSize(10);
      // // doc.text(20, 80, "Title: " + row.title);
      // // doc.text(20, 100, "Years: " + row.years);
      // for (let index = 0; index < totalqrcodePDf.length; index++) {
      //     const element = totalqrcodePDf[index];
      //     doc.addImage(element, "JPEG", 140, 110, 90, 90, 'SLOW');
      // }
      // //doc.save("QrCode.pdf");
      // doc.save("QrCode.pdf");
    }
  };

  const printQRDuplicate = () => {
    if (DuplicateQrcodeList.length > 0) {
      let totalqrcodePDf = [];
      for (let index = 0; index < DuplicateQrcodeList.length; index++) {
        const element = DuplicateQrcodeList[index];
        const qrCodeURL = document
          .getElementById("qrCodeElDuplicate" + index)
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        totalqrcodePDf.push(qrCodeURL);
      }
      var doc = new jsPDF();
      doc.text(20, 30, ArticleName);
      let noofpage = Math.ceil(totalqrcodePDf.length / 12);
      let pagenum = 1;
      let rownumber = 1;
      let posisionnumber = 1;
      doc.text(20, 10, ArticleName);
      for (let index = 0; index < totalqrcodePDf.length; index++) {
        const element = totalqrcodePDf[index];
        if (rownumber === 1) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 20, 50, 50, "FD");

            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 20, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 20, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 2;
          }
        } else if (rownumber === 2) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 80, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 80, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 80, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 3;
          }
        } else if (rownumber === 3) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 140, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 140, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 140, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 4;
          }
        } else if (rownumber === 4) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 200, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 200, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 200, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 1;
            if (pagenum < noofpage) {
              doc.addPage();
              pagenum = pagenum + 1;
            }
          }
        }
      }
      window.open(doc.output("bloburl"));
      doc.autoPrint();
      doc.close();
    }
  };
  const toggleQrcode = (row) => {
    setDuplicateQrcodeList([]);
    setQrcodeQty(0);
    setmodalQrcode(!modalQrcode);
    if (row?.codeString) {
      let qrcodestring = domainFrontUrl.current + row?.codeString;
      // setQrCodeString(Config.FrontUrl + row?.codeString);
      setQrCodeString(qrcodestring);
    }
    else {
      setQrCodeString("")
    }
    setQrCodeID(row?._id);
    setbulkQrcodeInformation(row);
  };
  const ModelClosed = () => {
    setmodalQrcode(!modalQrcode);
    setQrCodeString("");
    setQrCodeID("");
    setbulkQrcodeInformation("");
    setDuplicateQrcodeList([]);
    setQrcodeQty(0);
  };
  const toggleDuplicateSendEmail = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisDuplicateToEamil(!isDuplicateToEamil);
  };
  const sendpdfEmail = async () => {
    if (DuplicateQrcodeList.length > 0) {
      let totalqrcodePDf = [];
      for (let index = 0; index < DuplicateQrcodeList.length; index++) {
        const element = DuplicateQrcodeList[index];
        const qrCodeURL = document
          .getElementById("qrCodeElDuplicate" + index)
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        totalqrcodePDf.push(qrCodeURL);
      }

      var doc = new jsPDF();
      doc.text(20, 30, ArticleName);
      let noofpage = Math.ceil(totalqrcodePDf.length / 12);
      let pagenum = 1;
      let rownumber = 1;
      let posisionnumber = 1;
      doc.text(20, 10, ArticleName);
      for (let index = 0; index < totalqrcodePDf.length; index++) {
        const element = totalqrcodePDf[index];
        if (rownumber === 1) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 20, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 20, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 20, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 2;
          }
        } else if (rownumber === 2) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 80, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 80, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 80, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 3;
          }
        } else if (rownumber === 3) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 140, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 140, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 140, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 4;
          }
        } else if (rownumber === 4) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 200, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 200, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 200, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 1;
            if (pagenum < noofpage) {
              doc.addPage();
              pagenum = pagenum + 1;
            }
          }
        }
      }
      let file = await doc.output();
      let url = "data:application/pdf;base64," + (await btoa(file));
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      let filelist = [];
      let filedata = {
        path: "pdf",
        sourceURL: "pdf",
        data: url,
      };
      filelist.push(filedata);

      let ContactHelpModel = {
        UserCompanyID: loginid,
        name: ".pdf",
        subject: "Qrcode",
        body: ArticleName,
        attachFileList: filelist,
        ToEmailList: subToEmail,
      };
      fetch(Config.apiUrl + "EmailQueue/SendMailOfQrcodesend?ispdf=true", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(ContactHelpModel),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          // console.log("123=====>", resp1)
          if (resp1 === true) {
            toggleDuplicateSendEmail();
            swal("Thank You", "Successfully  send email", "success");
          } else {
            swal("Sorry", "Pleace  Contact Admin.", "error");
          }
        });
    }
  };

  const GetAllvendor = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    setvendorlist([]);
    fetch(Config.apiUrl + "Vendor/DropdownList", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setvendorlist(result);
        }
      });
    });
  };
  const onchangeCombinationQrcode = (event) => {
    setselectCombinationNewID(event.target.value);
  };
  const onchangeVendor = (event) => {
    setVendorID(event.target.value);
  };
  const onchangeselectBatchnumber = (event) => {
    setBatchnumber(event.target.value);
    setselectBatchNumbername(event.target.value);
  };
  const onchangeExpiryDate = (date) => {
    setExpiryDate(date);
    if (date !== null && date !== "" && date !== undefined) {
      let Finaldate = Moment(date).format("YYYY-MM-DD");
      setExpiryDateFinal(Finaldate);
    } else {
      setExpiryDateFinal(null);
    }
  };
  const onchangeManufactureDate = (date) => {
    if (date !== null && date !== "" && date !== undefined) {
      let Finaldate = Moment(date).format("YYYY-MM-DD");
      setManufactureDateFinal(Finaldate);
      setManufactureDate(date);
    } else {
      setManufactureDateFinal(null);
      setManufactureDate(null);
    }
  };

  const printQrcodeArticle = () => {
    const qrCodeURL = document
      .getElementById("ArticleqrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    var doc = new jsPDF("p", "pt", "A4");
    doc.setFontSize(22);
    doc.text(20, 30, ArticleName);
    doc.setFontSize(10);
    // doc.text(20, 80, "Title: " + row.title);
    // doc.text(20, 100, "Years: " + row.years);
    doc.addImage(qrCodeURL, "JPEG", 100, 100, 200, 200);
    //doc.save("QrCode.pdf");
    doc.autoPrint();
    doc.output("dataurlnewwindow");
  };

  const getallbatchNumber = async (ArticleIdObj) => {
    if (
      ArticleIdObj !== null &&
      ArticleIdObj !== "" &&
      ArticleIdObj != undefined
    ) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setbatchNumberList([]);
      fetch(
        Config.apiUrl +
        "QrcodeBatchNumber/GetallQrcodeBatchnumber?ProductID=" +
        ArticleIdObj,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result != null) {
            setbatchNumberList(result);
          }
        });
      });
    }
  };
  const onEditBindAttributeValue = async (ArticleIDObj) => {
    setisBindAttributeLoding(true);
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
      "Attribute/ArticleAttributeList?ArticleID=" +
      ArticleIDObj +
      "&ArticleTypeID=" +
      "",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((result) => {
      result?.json().then((resp) => {
        if (resp.articleID != null && resp.articleID != "") {
          setisAttributeshow(true);
          setCombinationList(resp.attributeCombinationList);
          setisBindAttributeLoding(false);
        } else {
          setisAttributeshow(false);
          setCombinationList([]);
          setisBindAttributeLoding(false);
        }
      });
    });
  };
  const toggleNewProductQrCodeisOpen = async (row) => {
    setisrefresh(true);
    document.body.style.overflow = "hidden";

    await getallbatchNumber(row?._id);
    await getqrcodeAttributesNew(row?._id);
    if (row?.articlePics) {
      let FullPath = `${Config.contentUrl + row?.articlePics}`;
      setArticlesProfileImage(FullPath);
    } else {
      setArticlesProfileImage("");
    }
    setArticleName(row?.articleName);
    setArticlescategoryName(row?.categorydetail?.name);
    setArticlessubcategorynewName(row?.subCategoryDetail?.name);
    setArticlesNo(row?.articleNumber);
    setArticleId(row?._id);
    setnewqrcodeid(row?._id);
    setisrefresh(false);
    if (
      row?.articleType?.name === "Variable product" ||
      row?.articleType?._id === "62ac68e2830ffdde1c0b09b9"
    ) {
      await onEditBindAttributeValue(row?._id).then(
        setNewProductQrCodeisOpen(true)
      );
    } else {
      setisAttributeshow(false);
      setCombinationList([]);
      setNewProductQrCodeisOpen(true);
    }
    document.body.style.overflow = "auto";
  };
  const toggleNewProductQrCodeisOpenclose = () => {
    setCombinationList([]);
    setnewqrcodeid("");
    setArticlessubcategorynewName("");
    setArticlescategoryName("");
    setArticleName("");
    setArticlesProfileImage("");
    setArticleId("");
    setArticlesNo("");
    setVendorID("");

    setNewProductQrCodeisOpen(false);
  };
  const batchnumbertoggle = () => {
    setBatchNumberError("");
    setBatchnumber("");
    setBatchnumberisOpen(!batchnumberisOpen);
  };
  const addbatchnumber = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let retval = true;
    if (
      BatchNumber === null ||
      BatchNumber === "" ||
      BatchNumber === undefined
    ) {
      retval = false;
      setBatchNumberError("please enter a batch number");
      return;
    }

    var data = {
      BatchNumber: BatchNumber,
      ProductID: newqrcodeid,
      UserCompanyID: loginid,
      CreatedBy: loginid,
      UpdatedBy: loginid,
    };
    fetch(Config.apiUrl + "QrcodeBatchNumber/Create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(data),
    })
      .then((result1) => {
        result1.json().then((resp) => {
          if (resp !== null && resp.data !== null) {
            getallbatchNumber(newqrcodeid);
            setBatchnumber("");
            swal("Congratulations ! save successfully.", {
              icon: "success",
            });
          } else {
          }
        });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  const handleColor2 = (event) => {
    const colorValue = event.target.value;
    setColor2("#" + colorValue);
  };
  const handleColor3 = (event) => {
    const colorValue = event.target.value;
    setColor3("#" + colorValue);
  };
  const handleColor1 = (event) => {
    const colorValue = event.target.value;
    setColor1("#" + colorValue);
  };



  const handleOptionChange = (event) => {
    setIsBackgroundUrl(true);
    setuploadBackgroundImage(null);
    setColor2("");


  };
  const handleOptionChangecolor = (event) => {
    setIsBackgroundUrl(false);
    setuploadBackgroundImage(null);
    setpageBackgroundImage("");
    setColor2("#01F9C6");
  };

  const selectdefaultTheme = (e) => {
    const id = e.target.value;
    if (id != null && id != "" && id != undefined) {
      setDefaultThemeId(id);
      let defaultThemelistold = [...defaultThemelistTemp];
      if (defaultThemelistold != null && defaultThemelistold != undefined && defaultThemelistold != "" && defaultThemelistold.length > 0) {
        let selectitem = defaultThemelistold.find(x => x._id == id);
        if (selectitem != null && selectitem != "" && selectitem != undefined) {
          setuploadBackgroundImage(null);
          setColor1(selectitem?.color1);
          setColor2(selectitem?.color2);
          setColor3(selectitem?.color3);
          setIsBackgroundUrl(selectitem?.isBackgroundUrl);

          if (selectitem?.titleFontSize !== null && selectitem?.titleFontSize !== "" && selectitem?.titleFontSize !== undefined) {
            let titlefontsizeold = selectitem?.titleFontSize.split('px');
            settitlefontsize(parseInt(titlefontsizeold[0]));
            settitlefontsizeFinal(selectitem?.titleFontSize);
          }
          else {
            settitlefontsize(16);
            settitlefontsizeFinal("16px")
          }

          if (selectitem?.descriptionFontSize !== null && selectitem?.descriptionFontSize !== "" && selectitem?.descriptionFontSize !== undefined) {
            let titlefontsizeold = selectitem?.descriptionFontSize.split('px');
            setdescriptionfontsize(parseInt(titlefontsizeold[0]));
            setdescriptionfontsizeFinal(selectitem?.descriptionFontSize)
          }
          else {
            setdescriptionfontsize(16);
            setdescriptionfontsizeFinal("16px")
          }

          if (selectitem?.dropDownDetailTitleFontSize !== null && selectitem?.dropDownDetailTitleFontSize !== "" && selectitem?.dropDownDetailTitleFontSize !== undefined) {
            let titlefontsizeold = selectitem?.dropDownDetailTitleFontSize.split('px');
            setCkeditorTitleFontSize(parseInt(titlefontsizeold[0]));
            setCkeditorTitleFontSizeFinal(selectitem?.dropDownDetailTitleFontSize)
          }
          else {
            setCkeditorTitleFontSize(16);
            setCkeditorTitleFontSizeFinal("16px")
          }

          if (selectitem?.dropDownDetailDisciptionFontSize !== null && selectitem?.dropDownDetailDisciptionFontSize !== "" && selectitem?.dropDownDetailDisciptionFontSize !== undefined) {
            let titlefontsizeold = selectitem?.dropDownDetailDisciptionFontSize.split('px');
            setCkeditorDescriptionFontSize(parseInt(titlefontsizeold[0]));
            setCkeditorDescriptionFontSizeFinal(selectitem?.dropDownDetailDisciptionFontSize)
          }
          else {
            setCkeditorDescriptionFontSize(16);
            setCkeditorDescriptionFontSizeFinal("16px")
          }
        }
      }
    }
    else {
      setDefaultThemeId("");
    }

  }

  const clereproducttheme = () => {
    setDefaultThemeId("");
    setuploadBackgroundImage(null);
    settitlefontsize(16);
    settitlefontsizeFinal("16px");
    setdescriptionfontsize(16);
    setdescriptionfontsizeFinal("16px");
    setCkeditorTitleFontSize(16);
    setCkeditorTitleFontSizeFinal("16px")
    setCkeditorDescriptionFontSize(16);
    setCkeditorDescriptionFontSizeFinal("16px");
    setIsBackgroundUrl(false);
    setpageBackgroundImage("");
    setColor1("#0a0303");
    setColor2("#01F9C6")
    setColor3("#617C58")
  }

  const getProductQrcodeTheme = (articleidObj) => {
    fetch(Config.apiUrl + "productQrcodeTheme/GetProductQrcodeThemeByArticleProductId?ArticleProductId=" + articleidObj, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        if (resp1 !== null) {
          setProductQrcodeThemeId(resp1?._id ? resp1?._id : "");
          setDefaultThemeId(resp1?.defaultThemeId ? resp1?.defaultThemeId : "");

          if (resp1?.titleFontSize !== null && resp1?.titleFontSize !== "" && resp1?.titleFontSize !== undefined) {
            let titlefontsizeold = resp1?.titleFontSize.split('px');
            settitlefontsize(titlefontsizeold[0]);
            settitlefontsizeFinal(resp1?.titleFontSize)
          }
          else {
            settitlefontsize(16);
            settitlefontsizeFinal("16px")
          }

          if (resp1?.descriptionFontSize !== null && resp1?.descriptionFontSize !== "" && resp1?.descriptionFontSize !== undefined) {
            let titlefontsizeold = resp1?.descriptionFontSize.split('px');
            setdescriptionfontsize(titlefontsizeold[0]);
            setdescriptionfontsizeFinal(resp1?.descriptionFontSize)
          }
          else {
            setdescriptionfontsize(16);
            setdescriptionfontsizeFinal("16px")
          }

          if (resp1?.dropDownDetailTitleFontSize !== null && resp1?.dropDownDetailTitleFontSize !== "" && resp1?.dropDownDetailTitleFontSize !== undefined) {
            let titlefontsizeold = resp1?.dropDownDetailTitleFontSize.split('px');
            setCkeditorTitleFontSize(titlefontsizeold[0]);
            setCkeditorTitleFontSizeFinal(resp1?.dropDownDetailTitleFontSize)
          }
          else {
            setCkeditorTitleFontSize(16);
            setCkeditorTitleFontSizeFinal("16px")
          }

          if (resp1?.dropDownDetailDisciptionFontSize !== null && resp1?.dropDownDetailDisciptionFontSize !== "" && resp1?.dropDownDetailDisciptionFontSize !== undefined) {
            let titlefontsizeold = resp1?.dropDownDetailDisciptionFontSize.split('px');
            setCkeditorDescriptionFontSize(titlefontsizeold[0]);
            setCkeditorDescriptionFontSizeFinal(resp1?.dropDownDetailDisciptionFontSize)
          }
          else {
            setCkeditorDescriptionFontSize(16);
            setCkeditorDescriptionFontSizeFinal("16px")
          }
          setuploadBackgroundImage(null);
          if (resp1?.isBackgroundUrl == true) {
            setColor2(resp1?.color2 ? resp1?.color2 : "");
            setIsBackgroundUrl(resp1?.isBackgroundUrl);
          }
          else {
            setColor2(resp1?.color2 ? resp1?.color2 : "#01F9C6");
            setIsBackgroundUrl(resp1?.isBackgroundUrl);
          }
          setColor1(resp1?.color1 ? resp1?.color1 : "#0a0303");
          setColor3(resp1?.color3 ? resp1?.color3 : "#FFFFFF");
        }
      });

  }

  const GetAllProductInfo = (articleidObj) => {
    setisLoading(true);
    if (
      articleidObj != null &&
      articleidObj != "" &&
      articleidObj != undefined
    ) {
      setisLoading(true);
      getProductQrcodeTheme(articleidObj);
      fetch(
        Config.apiUrl +
        "ArticleProduct/GetArticleAllInformationWithOutUserCompanyId?id=" +
        articleidObj,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result._id != null) {
            setproductinfo(result);
            setPreviewModalisOpen(true);
          }
          else {
            setproductinfo(null);
          }
          setTimeout(() => {
            setisLoading(false);
          }, 3000);
        });
      });
    }
  };

  const GetalldefaultTheme = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    fetch(Config.apiUrl + "defaultTheme/GetAllDefaultQrcodeTheme", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        if (resp1 !== null && resp1?.length > 0) {
          setDefaultThemelistTemp(resp1);
          const DefaultThemelisttemp = [];
          const temp = { label: "--- select Theme -- ", value: "" };
          DefaultThemelisttemp.push(temp);
          if (resp1 !== null && resp1 !== undefined && resp1 !== "") {
            for (let index = 0; index < resp1.length; index++) {
              const element = resp1[index];
              if (element != null && element != undefined) {
                const data = {
                  label: element?.themeName ? element?.themeName : "N/A",
                  value: element?._id
                }
                DefaultThemelisttemp.push(data);
              }
            }
          }
          setDefaultThemelist(DefaultThemelisttemp);
        } else {
          const temp = { label: "--- select Theme -- ", value: "*" };
          setDefaultThemelist(temp);
          setDefaultThemelistTemp([]);
        }
      });
  }

  const togglepreviewModal = (_id) => {
    if (_id != null && _id != "" && _id != undefined) {
      GetAllProductInfo(_id)
    }
    else {
      setPreviewModalisOpen(false);
    }
  };

  const uploadBackgroundImageFile = (e) => {
    setuploadBackgroundImage(e.target.files[0]);
    setColor2(URL.createObjectURL(e.target.files[0]))
  }

  const addupdateProductQrcodeTheme = () => {
    setisbuttonLoading(true);
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    if (uploadBackgroundImage != null && uploadBackgroundImage != "" && uploadBackgroundImage != undefined) {
      const formData = new FormData();
      formData.append("body", uploadBackgroundImage);

      fetch(Config.apiUrl + "FileUpload/createBackgroundImage", {
        headers: {
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        method: "POST",
        body: formData,
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null && resp?.responseType == "Success") {
            const bodys = {
              "_id": productQrcodeThemeId,
              "articleProductId": productinfo?._id,
              "defaultThemeId": defaultThemeId,
              "isBackgroundUrl": IsBackgroundUrl,
              "Color1": Color1,
              "Color2": resp?.responseUrl,
              "Color3": Color3,
              "TitleFontSize": titlefontsizeFinal,
              "DescriptionFontSize": descriptionfontsizeFinal,
              "DropDownDetailTitleFontSize": ckeditorDescriptionFontSizeFinal,
              "DropDownDetailDisciptionFontSize": ckeditorTitleFontSizeFinal,
              "Sliderimground": "",
              "logoshadow": logoshadowFinal
            };
            fetch(
              Config.apiUrl +
              "productQrcodeTheme/CreateOrUpdateProductQrcodeTheme", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(bodys),
            })
              .then((response) => {
                if (response.ok) {
                  return response.json();
                }
                throw new Error("Something went wrong");
              })
              .then((resp1) => {
                // setisbuttonLoading(false);
                // if (resp1 === true) {
                //   clereproducttheme();
                //   setPreviewModalisOpen(false);
                //   swal("Thank You", "Your details are saved.", "success");
                // } else {
                //   swal("Sorry", "Your details are not saved", "error");
                // }
                setisbuttonLoading(false);
                if (resp1 === true) {
                  // clereproducttheme();
                  // setPreviewModalisOpen(false);
                  setissuccess(true);
                  setiserror(false);
                  setTimeout(function () {
                    setissuccess(false)
                  }, 5000);
                  //swal("Thank You", "Your details are saved.", "success");
                } else {
                  //swal("Sorry", "Your details are not saved", "error");
                  setissuccess(false);
                  setiserror(true);
                  setTimeout(function () {
                    setiserror(false)
                  }, 5000);
                }
              });
          }
          else {
            // setisbuttonLoading(false);
            // swal("Sorry", "Your details are not saved", "error");
            setisbuttonLoading(false);
            setissuccess(false);
            setiserror(true);
            setTimeout(function () {
              setiserror(false)
            }, 5000);
          }
        });
      });

    }
    else {
      const bodys = {
        "_id": productQrcodeThemeId,
        "articleProductId": productinfo?._id,
        "defaultThemeId": defaultThemeId,
        "isBackgroundUrl": IsBackgroundUrl,
        "Color1": Color1,
        "Color2": Color2,
        "Color3": Color3,
        "TitleFontSize": titlefontsizeFinal,
        "DescriptionFontSize": descriptionfontsizeFinal,
        "DropDownDetailTitleFontSize": ckeditorDescriptionFontSizeFinal,
        "DropDownDetailDisciptionFontSize": ckeditorTitleFontSizeFinal,
        "Sliderimground": "",
        "logoshadow": logoshadowFinal
      };
      fetch(
        Config.apiUrl +
        "productQrcodeTheme/CreateOrUpdateProductQrcodeTheme", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(bodys),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          // if (resp1 === true) {
          //   clereproducttheme();
          //   setPreviewModalisOpen(false);
          //   setisLoading(false);
          //   swal("Thank You", "Your details are saved.", "success");
          // } else {
          //   setisLoading(false);
          //   swal("Sorry", "Your details are not saved", "error");
          // }
          setisbuttonLoading(false);
          if (resp1 === true) {
            // clereproducttheme();
            // setPreviewModalisOpen(false);
            setissuccess(true);
            setiserror(false);
            setTimeout(function () {
              setissuccess(false)
            }, 5000);
            //swal("Thank You", "Your details are saved.", "success");
          } else {
            //swal("Sorry", "Your details are not saved", "error");
            setissuccess(false);
            setiserror(true);
            setTimeout(function () {
              setiserror(false)
            }, 5000);
          }
        });
    }

  }
  const onClickCollapse = (id) => {
    if (id != null && id != "" && id != undefined) {
      let Collapseidlistold = [...Collapseidlist];
      if (Collapseidlistold.length > 0) {
        let olddata = Collapseidlistold.filter((e) => e.includes(id));
        if (olddata != null && olddata != "" && olddata != undefined) {
          Collapseidlistold.pop(olddata);
        }
        else {
          Collapseidlistold.push(id);
        }
      }
      else {
        Collapseidlistold.push(id);
      }
      setCollapseidlist(Collapseidlistold);
    }
  }
  const OnIscertificatesClick = () => {
    setiscertificatesopen(!iscertificatesopen);
  }

  useEffect(() => {
    getqrcodeAttributesNew(newqrcodeid);
  }, [
    VendorID,
    ManufactureDate,
    selectBatchNumbername,
    selectCombinationNewID,
    ExpiryDate,
  ]);

  return (
    <>
      <div>
        <LoaderSpinner isrefresh={isrefresh || isBindAttributeLoding} />
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <a href="/home">Home</a>
          </li>
          <li className="breadcrumb-item active">Production QR Code</li>
        </ol>
        <h1 className="page-header">Production QR Code</h1>
        <div className="mb-2">
          <div className="row justify-content-end">
            <button
              className="btns btn btn-primary search-btn  mr-2 mb-1"
              onClick={(e) => {
                AddArticleDetails("");
              }}
            >
              <i class="fas fa-lg fa-fw m-r-5 fa-plus-square icon"></i>
              Add new
            </button>
            <div className="btns btn-group  mr-2  mb-1">
              <button
                className="btn btn-green"
                // onClick={(e) => {
                //   ExportDeatlis();
                // }}
                onClick={async (e) => {
                  try {
                    let response = await Checkexportdata();
                    if (response === true || response === "true") {
                      ExportDeatlis();
                    } else {
                      swal(
                        "oops!",
                        "Sorry! to increase your export data enabled   .",
                        "warning"
                      );
                    }
                  } catch (error) {
                    console.log("error!", error);
                  }
                }}
              >
                <i class="fas  fa-sm fa-fw m-r-5 fa-download icon"></i>
                Export{" "}
              </button>
            </div>

            <button
              type="button"
              className="btns btn  btn-danger mr-2 mb-1"
              onClick={onSelcetdProductDelete}
            >
              <i className="far fa-lg fa-fw m-r-5 fa-trash-alt icon"></i>
              Delete (selected)
            </button>
          </div>
        </div>
        <Panel>
          <PanelHeader>
            <div>
              <h4 className="mb-0 text-light">
                <i className="fas fa-fw m-r-10 fa-search"></i> Search
              </h4>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="row">
              <div className="col-xl-6 px-4">
                <form action="javascript:void(0);" method="POST">
                  <fieldset>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Name{" "}
                      </label>
                      <div className="d-none d-md-block d-lg-block">:</div>
                      <div className="col-md-7">
                        <input
                          type="text"
                          className="form-control input-height"
                          placeholder="Enter name"
                          value={ProductName}
                          onChange={(e) => {
                            onChangeProductName(e);
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Category{" "}
                      </label>
                      <div className="d-none d-md-block d-lg-block">:</div>
                      <div className="col-md-7">
                        <select
                          className="default-select2 form-control"
                          value={CategoryId}
                          onChange={onChangeCategory}
                        >
                          <option value="" selected>
                            --- Select Category ---
                          </option>
                          {CategoryList.map((item) => (
                            <option value={item._id}>{item.name}</option>
                          ))}
                        </select>
                        {CategoryError.length > 0 && (
                          <span style={{ color: "red", marginLeft: 6 }}>
                            {CategoryError}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="form-group row m-b-10 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Search sub Category
                      </label>
                      <div className="d-none d-md-block d-lg-block">:</div>
                      <div className="col-md-7">
                        <div className="form-check">
                          <input
                            className="form-check-input checkbox-label"
                            type="checkbox"
                            checked={issubcategoryshow}
                            onChange={handleChangeCategory}
                            id="defaultCheckbox"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="defaultCheckbox"
                          ></label>
                        </div>
                      </div>
                    </div>
                    {issubcategoryshow === true ? (
                      <div className="form-group row m-b-15 d-flex align-items-center">
                        <label className="col-md-4 col-form-label product-lable">
                          sub Category{" "}
                        </label>
                        <div className="d-none d-md-block d-lg-block">:</div>
                        <div className="col-md-7">
                          <select
                            class="default-select2 form-control"
                            value={subcategoryId}
                            onChange={onChangeSubCategory}
                          >
                            <option value="" selected>
                              --- Select Category ---
                            </option>
                            {subcetgoryList.map((item) => (
                              <option value={item._id}>{item.name}</option>
                            ))}
                            {subcategoryIdError.length > 0 && (
                              <span style={{ color: "red", marginLeft: 6 }}>
                                {subcategoryIdError}
                              </span>
                            )}
                          </select>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label  product-lable">
                        Label{" "}
                      </label>
                      <div className="d-none d-md-block d-lg-block">:</div>
                      <div className="col-md-7">
                        <select
                          className="default-select2  form-control"
                          value={LabelId}
                          onChange={onChangeLabeldrop}
                        >
                          <option value="" selected>
                            --- Select Label ---
                          </option>
                          {LabelList.map((item) => (
                            <option value={item.value}>{item.text}</option>
                          ))}
                        </select>
                        {LabelError.length > 0 && (
                          <span style={{ color: "red", marginLeft: 6 }}>
                            {this.state.LabelError}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label  product-lable">
                        Vendor{" "}
                      </label>
                      <div className="d-none d-md-block d-lg-block">:</div>
                      <div className="col-md-7">
                        <select
                          className="default-select2  form-control"
                          value={SupplierId}
                          onChange={onChangeSupplierdroptype}
                        >
                          <option value="0" selected>
                            --- Select Vendor ---
                          </option>
                          {SupplierList.map((item) => (
                            <option value={item.value}>{item.text}</option>
                          ))}
                        </select>
                        {SupplierError.length > 0 && (
                          <span style={{ color: "red", marginLeft: 6 }}>
                            {SupplierError}
                          </span>
                        )}
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
              <div className="col-xl-6 px-4">
                <form action="javascript:void(0);" method="POST">
                  <fieldset>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Type{" "}
                      </label>
                      <div className="d-none d-md-block d-lg-block">:</div>
                      <div className="col-md-7">
                        <select
                          className="default-select2  form-control"
                          value={ArticlesTypeId}
                          onChange={(e) => {
                            onChangeProductdroptype(e);
                          }}
                        >
                          <option value="0" selected>
                            --- Select Product Type ---
                          </option>
                          {ArticlesTypeList.map((item) => (
                            <option value={item.value}>{item.text}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Published{" "}
                      </label>
                      <div className="d-none d-md-block d-lg-block">:</div>
                      <div className="col-md-7">
                        <select
                          class="default-select2 form-control"
                          value={IsPublished}
                          onChange={onChangePublished}
                        >
                          <option value="">Select Published</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        SKU
                      </label>
                      <div className="d-none d-md-block d-lg-block">:</div>
                      <div className="input-group col-md-7 p-r-10 p-l-10">
                        <input
                          type="text"
                          className="form-control input-height"
                          value={ArticleSKU}
                          onChange={onChangeArticleSKU}
                        />
                      </div>
                    </div>
                    {rolename === "Admin" || rolename === "SuperAdmin" ? (
                      <div className="form-group row m-b-15 d-flex align-items-center">
                        <label className="col-md-4 col-form-label product-lable">
                          User
                        </label>
                        <div className="d-none d-md-block d-lg-block">:</div>
                        <div className="col-md-7">
                          <Select
                            search
                            options={subuserlist}
                            value={selectuserID}
                            onChange={(e) => {
                              setselectuseronlyID(e.value);
                              setselectuserID(e);
                            }}
                            placeholder="Choose login user"
                          />
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </fieldset>
                </form>
              </div>
            </div>
            <div className="row  justify-content-center">
              <button
                type="button"
                className="btn btn-primary search-btn d-flex align-items-center mr-2"
                onClick={SearchFilter}
              >
                <i className="fas fa-lg fa-fw m-r-10 fa-search "></i>
                Search
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={(e) => {
                  ClereHedersearch();
                }}
              >
                Reset
              </button>
            </div>
          </PanelBody>
        </Panel>

        <Panel>
          <PanelHeader>
            <h5 className="text-light mb-0">Product QR Code</h5>
          </PanelHeader>

          <hr class="m-0" />
          <PanelBody>
            <div className="row">
              <div className="col-xl-8 d-flex align-items-center">
                <div className="form-group  d-flex mb-0 m-r-10 align-items-center allPublishedinput">
                  <label className="col-form-label p-0">All</label>
                  <input
                    type="email"
                    className="form-control"
                    id="exampleInputEmail2"
                    onKeyUp={(e) => {
                      ArticleDetailsSearch(e.target.value);
                    }}
                    placeholder={"" + TotalCount + ""}
                  />
                </div>
                <div className="form-group  d-flex mb-0 m-r-10 align-items-center allPublishedinput">
                  <label className="col-form-label p-0"> Published</label>
                  <input
                    type="email"
                    className="form-control"
                    id="exampleInputEmail2"
                    onKeyUp={(e) => {
                      ArticleDetailsSearch(e.target.value);
                    }}
                    placeholder={"" + TotleCountPublished + ""}
                  />
                </div>
                <div className="display">
                  <select
                    className="form-control"
                    value={PerPageCount}
                    onChange={(e) => {
                      handlePageCountChange(Number(e.target.value));
                    }}
                  >
                    {PaggingList.map((pageSize) => {
                      return pageSize == TotalCount ? (
                        <option key={pageSize} value={pageSize}>
                          Show All
                        </option>
                      ) : (
                        <option key={pageSize} value={pageSize}>
                          Show {pageSize}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>

            <div class="table-responsive mt-3">
              <table
                class="table table-bordered table-striped text-center"
                {...getTableProps()}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr
                      {...headerGroup.getHeaderGroupProps()}
                      style={{ textAlign: "center" }}
                    >
                      {headerGroup.headers.map((column) => (
                        <th
                          className="align-middle"
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          <div
                            class="d-flex table-header"
                            style={{ minWidth: "" }}
                          >
                            <span>{column.render("Header")}</span>
                            <span
                              onClick={(e) => {
                                handleColumnSort(column);
                              }}
                            >
                              {column.sortable ? (
                                column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
                                  ) : (
                                    <i className="fa fa-sort-up fa-fw f-s-14 text-blue"></i>
                                  )
                                ) : (
                                  <i className="fa fa-sort fa-fw f-s-14 opacity-3"></i>
                                )
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map((row, i) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => {
                          return (
                            <td
                              {...cell.getCellProps()}
                              className="align-middle"
                            >
                              {cell.render("Cell")}{" "}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div class="d-flex align-items-center justify-content-between flex-wrap">
              <div className="d-flex align-items-center">
                <button className="btn btn-default  m-r-10">
                  All Products QR Codes
                </button>
                <div>
                  Showing{" "}
                  <strong>
                    {CurrentPageNo} of {Math.ceil(TotalCount / PerPageCount)}
                  </strong>{" "}
                  pages
                </div>
              </div>
              <ul class="pagination justify-content-end flex-wrap align-items-center mt-3">
                <li class="page-item">
                  {canPreviousPage == true ? (
                    <a
                      class="page-link mr-2"
                      href="javascript:void(0);"
                      onClick={() => gotoPage(0)}
                    >
                      Previous
                    </a>
                  ) : (
                    <a
                      class="page-link mr-2"
                      href="javascript:void(0);"
                      disabled={true}
                    >
                      Previous
                    </a>
                  )}
                </li>

                {PaginationGroupList.map((item, index) => (
                  <li>
                    <button
                      key={index}
                      onClick={changePage}
                      className={`btn ml-2 ${CurrentPageNo === item ? "page-link-1" : "btn-white"
                        }`}
                    >
                      <span>{item}</span>
                    </button>
                  </li>
                ))}

                <li class="page-item ml-2">
                  {canNextPage == true ? (
                    <a
                      class="page-link"
                      href="javascript:void(0);"
                      onClick={() => nextPage()}
                    >
                      Next
                    </a>
                  ) : (
                    <a
                      class="page-link"
                      href="javascript:void(0);"
                      disabled={true}
                    >
                      Next
                    </a>
                  )}
                </li>
              </ul>
            </div>
          </PanelBody>
        </Panel>
      </div>


      <Modal
        isOpen={PreviewModalisOpen}
        toggle={PreviewModalisOpen}
        onHide={() => {
          togglepreviewModal("");
        }}

        className="modal-size"

        size="xl" >

        <ModalHeader toggle={() => { togglepreviewModal("") }} className="modalheader">
          <h4 className="text-white mb-0">Preview Theme</h4>
        </ModalHeader>
        <ModalBody style={{ overflowY: 'scroll', scrollbarWidth: 'none', MsOverflowStyle: 'none' }}>
          <div className='row px-3' style={{ height: '765px', overflow: 'hidden' }}>
            <div className='col-xl-6' style={{ overflowY: "scroll", flex: 1, height: '750px' }}>
              <div className="row " >

                <dv className=" mt-2 color-picker-main">
                  <b><h5 style={{ color: 'black' }}>Select Theme </h5></b>
                  <select
                    className="default-select2 form-control col-xl-6" onChange={(e) => { selectdefaultTheme(e) }} value={defaultThemeId}>
                    {defaultThemelist?.length > 0 ? defaultThemelist?.map(
                      (item) => {
                        return <option value={item?.value}>
                          {item.label}
                        </option>
                      }) : <></>}
                  </select>
                </dv>

                <div className="" style={{ marginTop: "40px" }}>
                  <b><h5 style={{ color: 'black' }}>Select Page Background Type </h5></b>
                  <div className="d-flex align-items-center">
                    <div className="mt-2" >
                      <input
                        type="radio"
                        value="color"
                        checked={IsBackgroundUrl == false ? true : false}
                        onChange={(e) => { handleOptionChangecolor(e) }}
                      />
                      <label className="ml-2">Colour</label>
                    </div>
                    <div className="ml-3 mt-2">
                      <input
                        type="radio"
                        value="image"
                        checked={IsBackgroundUrl == true ? true : false}
                        onChange={(e) => { handleOptionChange(e) }}
                      />
                      <label className="ml-2">Image</label>
                    </div>
                  </div>
                </div>

                {IsBackgroundUrl === false ?
                  <div className="color-picker-main" style={{ marginTop: "40px" }}>
                    <b><h5 style={{ color: 'black' }}>Select Background Colour </h5></b>
                    <div className="d-flex align-items-center">
                      <ColorPicker
                        inputId="page-text-color"
                        format="hex"
                        value={Color2}
                        // hideInput={["rgb", "hsv"]}
                        // color={Color2} 
                        onChange={(e) => { handleColor2(e) }}
                        className="mb-3 color-picker-custom"
                      />
                    </div>
                  </div>
                  : <></>}

                {IsBackgroundUrl === true ?
                  <div className="color-picker-main" style={{ marginTop: "40px" }}>
                    <b><h5 style={{ color: 'black' }}>Select Background Image</h5></b>
                    <div className="d-flex flex-column align-items-center custom-file file-upload-height">
                      {/* <input type="file" onChange={(e) => { uploadBackgroundImageFile(e) }}  accept="image/x-png, image/gif, image/jpeg" max-size="2000"></input> */}

                      <input type="file" onChange={(e) => { uploadBackgroundImageFile(e) }} accept="image/x-png, image/gif, image/jpeg" max-size="2000" className="custom-file-input file-upload-height" />
                      <label className=" file-upload-1 file-upload-height" for="customFile ">
                        {
                          (uploadBackgroundImage != null && uploadBackgroundImage != undefined && uploadBackgroundImage != "") ?
                            <img
                              alt=""
                              src={Color2}
                              className="width-70 height-70 f-s-20 text-center rounded "

                            /> : Color2 ?
                              <img
                                alt=""
                                src={Config.contentUrl + Color2}
                                className="width-70 height-70 f-s-20 text-center rounded "
                              />
                              :
                              <img
                                alt=""
                                //src="../assets/img/new-images/images.png"
                                src={Config.contentUrlApi + "Frontend/images.png"}
                                className="width-70 height-70 f-s-20 text-center rounded "

                              />
                        }
                        <div className="file-upload-2 "><i className="ion ion-md-camera "></i></div>
                      </label>
                    </div>
                  </div>
                  : <></>}

                <div className="color-picker-main" style={{ marginTop: "40px" }}>
                  <b><h5 style={{ color: 'black' }}>Select Header And Button Colour</h5></b>
                  <div className="d-flex align-items-center">
                    <ColorPicker inputId="header-bg-color" format="hex" value={Color1}
                      onChange={(e) => {
                        handleColor1(e)
                      }} className="mb-3 color-picker-custom" />
                  </div>
                </div>

                <div className="color-picker-main " style={{ marginTop: "40px" }}>
                  <b><h5 style={{ color: 'black' }}>Select Tabs And Button Text Colour</h5></b>
                  <div className="d-flex align-items-center">
                    <ColorPicker inputId="page-text-color" format="hex" value={Color3}
                      onChange={(e) => {
                        //handlePageTextColorChange(e)
                        handleColor3(e)
                      }} className="mb-3 color-picker-custom" />
                  </div>
                </div>


              </div>
              <div className="container-fluid mt-3">
                <div className="row justify-content-center pb-3">
                  <button
                    type="button"
                    class="btn btn-success me-1 mb-1 shadow-add border-0"
                    onClick={(e) => {
                      //alert("Coming soon")
                      addupdateProductQrcodeTheme(e)
                    }}
                  >
                    {isbuttonLoading && (
                      <i class="fa fa-spinner fa-spin m-r-10"></i>
                    )}
                    Save changes

                  </button>
                </div>
              </div>
              {issuccess && <p style={{
                color: "green",
                fontfamily: "Nunito Sans",
                fontweight: "900",
                fontsize: "40px",
                marginbottom: "10px"
              }} > <strong>saved successfully! </strong> </p>}
              {iserror && <p style={{
                color: 'red',
                fontfamily: "Nunito Sans",
                fontweight: "900",
                fontsize: "40px",
                marginbottom: "10px"
              }}> <strong>Sorry! not saved correctly, please Try again </strong> </p>}
            </div>

            <div className='col-xl-6 d-flex  justify-content-center overflow-auto' style={{ position: 'sticky', top: 0, flex: 1 }}  >
              <img src={Config.contentUrlApi + "Frontend/iphone-frame.png"} style={{ position: 'absolute', width: '360px' }} />
              <div className="mobile-preview" style={{ height: '687px', width: '340px', overflowY: 'scroll', marginTop: '60px', borderBottomLeftRadius: 40, borderBottomRightRadius: 40, position: 'relative', zIndex: 9999 }}>
                <Theme
                  titlefontsize={titlefontsizeFinal}
                  descriptionfontsize={descriptionfontsizeFinal}
                  ckeditorTitleFontSize={ckeditorTitleFontSizeFinal}
                  ckeditorDescriptionFontSize={ckeditorDescriptionFontSizeFinal}
                  color1={Color1}
                  color2={Color2}
                  color3={Color3}
                  isBackgroundUrl={IsBackgroundUrl}
                  Productinfo={productinfo}
                  onClickCollapse={onClickCollapse}
                  selectcollapseidlist={Collapseidlist}
                  sliderimground={Sliderimground}
                  LogoshadowFinal={logoshadowFinal}
                  Iscertificatesopen={iscertificatesopen}
                  IscertificatesClick={(e) => { OnIscertificatesClick(e) }}
                  uploadBackgroundImage={uploadBackgroundImage}
                />
              </div>
            </div>

          </div>
        </ModalBody>

      </Modal >

      {/* Done */}
      <Modal
        isOpen={variationlistmodal}
        toggle={ProductVariations}
        className="lg-modal-size"
        onHide={() => {
          ProductVariations("");
        }}
      >
        <ModalHeader toggle={ProductVariations} className="modalheader">
          <h4 className="text-white mb-0">Product Variations</h4>
        </ModalHeader>
        <ModalBody>
          <div>
            {ArticlesVariationList?.length > 0 ? (
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <h3 className="mb-0">Product variations</h3>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex justify-content-md-end justify-content-sm-start">
                      <div className="btns btn-group  mr-2  my-2">
                        <button
                          className="btn btn-green"
                          //   onClick={(e) => {
                          //     Exportvariations();
                          //   }}
                          onClick={async (e) => {
                            try {
                              let response = await Checkexportdata();
                              if (response === true || response === "true") {
                                Exportvariations();
                              } else {
                                swal(
                                  "oops!",
                                  "Sorry! to increase your export data enabled   .",
                                  "warning"
                                );
                              }
                            } catch (error) {
                              console.log("error!", error);
                            }
                          }}
                        >
                          <i class="fas  fa-sm fa-fw m-r-5 fa-download icon"></i>
                          Export
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="row align-items-center py-3">
                      <div className="col-sm-8">
                        <div className="table-responsive  table-borderless ">
                          <table className="table m-b-0">
                            <tbody>
                              <tr>
                                <td className="bold">Name</td>
                                <td>{ArticlesName}</td>
                              </tr>
                              <tr>
                                <td className="bold">Article</td>
                                <td>{ArticlesNo}</td>
                              </tr>
                              <tr>
                                <td className="bold">Category</td>
                                <td>
                                  {ArticlescategoryName +
                                    "/" +
                                    ArticlessubcategoryName}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="variationsimg">
                          <img
                            src={ArticlesProfileImage}
                            className="img-fluid"
                            style={{ height: "140px" }}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src =
                                "../assets/img/new-images/images.png";
                            }}
                          ></img>
                        </div>
                        {/* <img src="../assets/img/user/user-1.jpg" /> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6"></div>
                </div>
              </div>
            ) : (
              <></>
            )}
            <DataTable
              //title=" Article Variation"
              columns={columnsVariant}
              data={ArticlesVariationList}
              defaultSortFieldId={6}
              //sortIcon={<SortIcon />}
              //sortIcon={<i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>}
              pagination
              selectableRows
              //selectedRows
              onSelectedRowsChange={handleChange}
              customStyles={customStyles}
              //onRowClicked
              //className='table'
              theme="solarized"
              striped

            // paginationServer
            // paginationTotalRows={totalRows}
            // onChangeRowsPerPage={handlePerRowsChange}
            // onChangePage={handlePageChange}
            // // progressPending={loading}
            // onRowMouseEnter={handleMouseEnter}
            // onRowMouseLeave={handleMouseLeave}
            // paginationDefaultPage={currentPage}
            // paginationPerPage={rowsPerPage}
            // paginationRowsPerPageOptions={[10, 15, 20, 30]}
            />
          </div>
          {/* <VariationList /> */}

          {/* <VariationListDatatable /> */}
        </ModalBody>
      </Modal>
      {/* Final */}
      <Modal isOpen={qrmodal} toggle={toggleqr}>
        <ModalHeader toggle={toggleqr} className="modalheader">
          <h5 className="text-white mb-0">Production QR code </h5>
        </ModalHeader>
        <ModalBody>
          <div className="d-flex justify-content-center mt-2">
            <h5 className="">{QrcodeProductname}</h5>
          </div>

          <div className="d-flex justify-content-center mt-2">
            <QRCode value={Qrcodestring} id="qrCodeEl" size={210} />
          </div>

          <div className="d-flex justify-content-center mt-4">
            <button
              type="submit"
              className="btn btn-warning  m-r-5 m-b-5"
              onClick={() => {
                printQrcode();
              }}
            >
              Print
            </button>
            <button
              type="submit"
              className="btn btn-warning m-b-5 m-r-5"
              onClick={() => {
                downloadQRCodeArticle();
              }}
            >
              Download
            </button>
            <button
              type="submit"
              className="btn btn-warning m-r-5 m-b-5"
              onClick={() => {
                toggleToEmail();
              }}
            >
              Send
            </button>
          </div>
        </ModalBody>
      </Modal>

      {/* Done  */}
      <Modal
        isOpen={TotalQrcodeModel}
        toggle={TotalQrcodeModelclose}
        className="lg-modal-size"
      >
        <ModalHeader toggle={TotalQrcodeModelclose} className="modalheader">
          <h4 className="text-white mb-0">Bulk QR codes</h4>
        </ModalHeader>
        <ModalBody>
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h3 className="mb-0">Bulk QR codes</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="row align-items-center py-3">
                  <div className="col-sm-8">
                    <div className="table-responsive  table-borderless ">
                      <table className="table m-b-0">
                        <tbody>
                          <tr>
                            <td className="bold">Name</td>
                            <td>
                              {totalQrcodeArticlename
                                ? totalQrcodeArticlename
                                : "N/A"}
                            </td>
                          </tr>
                          <tr>
                            <td className="bold">Article</td>
                            <td>
                              {totalQrcodeArticlenumber
                                ? totalQrcodeArticlenumber
                                : "N/A"}
                            </td>
                          </tr>
                          <tr>
                            <td className="bold">Category</td>
                            <td>
                              {totalQrcodecategory
                                ? totalQrcodecategory
                                : "N/A"}
                            </td>
                          </tr>
                          <tr>
                            <td className="bold">Created Date</td>
                            <td>
                              {totalQrcodeCreatedDate
                                ? totalQrcodeCreatedDate
                                : "N/A"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="variationsimg">
                      <img
                        src={totalQrcodeImage}
                        className="img-fluid"
                        style={{ height: "140px" }}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src =
                            "../assets/img/new-images/images.png";
                        }}
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6"></div>
            </div>
          </div>

          <div>
            <DataTable
              //title=" Article Variation"
              columns={columnsTotalQrcode}
              data={TotalQrcodelist}
              defaultSortFieldId={9}
              //sortIcon={<SortIcon />}
              sortIcon={
                <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
              }
              pagination
              //selectableRows
              //selectedRows
              onSelectedRowsChange={handleChange}
              customStyles={customStyles}
              //onRowClicked
              //className='table'
              theme="solarized"
              striped
            />
          </div>
          {/* <VariationList /> */}

          {/* <VariationListDatatable /> */}
        </ModalBody>
      </Modal>
      {/* Done  */}
      <Modal isOpen={modalArticleQroce} toggle={toggleArticle}>
        <ModalHeader toggle={toggleArticle} className="modalheader">
          <h5 className="text-white mb-0">Production QR code</h5>
        </ModalHeader>
        <ModalBody>
          <div className="row justify-content-center mt-2">
            <div className="col-xs-5 text-center  titlebgcontainer">
              <h5 className="mb-0 ">{QrcodeProductname}</h5>
            </div>
          </div>

          <div className="d-flex justify-content-center mt-2">
            {/* <img src="../assets/img/user/QR.png" alt="img" style={{ maxHeight: '250px' }} onerror="this.src='../assets/img/new-images/images.png';"></img> */}
            <QRCode value={Qrcodestring} id="qrCodeElBulk" size={210} />
          </div>

          <div className="d-flex justify-content-center mt-4">
            <button
              type="submit"
              className="btn btn-warning  m-r-5 m-b-5"
              onClick={() => {
                printQrcodeBulk();
              }}
            >
              Print
            </button>
            <button
              type="submit"
              className="btn btn-warning m-b-5 m-r-5"
              onClick={() => {
                downloadQRCodeBulk();
              }}
            >
              Download
            </button>
            <button
              type="submit"
              className="btn btn-warning m-r-5 m-b-5"
              onClick={() => {
                toggleToEmailBulk();
              }}
            >
              Send
            </button>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={QrCodeModalisOpen}
        toggle={QrCodeModalisOpen}
        className="modal-size"
      >
        <ModalHeader toggle={toggleQrCodeModal} className="modalheader">
          <h4 className="text-white mb-0">Create Product Variations QR code</h4>
        </ModalHeader>
        <ModalBody>
          <div className="row px-3">
            <div className="col-xl-6">
              <div className="row  align-items-center">
                <div className="col-xl-4 ">
                  {ArticlesProfileImage !== null &&
                    ArticlesProfileImage !== undefined &&
                    ArticlesProfileImage !== "" ? (
                    <img
                      src={ArticlesProfileImage}
                      alt
                      width="100%"
                      className="rounded"
                    />
                  ) : (
                    <img
                      src="../assets/img/user/noimage.jpg"
                      alt
                      width="100%"
                      className="rounded"
                    />
                  )}
                  <h5 className="m-t-10 mb-0 text-center">{ArticleName}</h5>
                </div>
              </div>
              <div className="m-t-30">
                <div className="row">
                  <h5 className="col-xl-4 mb-0">
                    <b>Article</b>
                  </h5>
                  <p>:</p>
                  <p className="col-xl-6"> {ArticlesNo} </p>
                </div>
                <div className="row">
                  <h5 className="col-xl-4 mb-0">
                    <b>Category</b>
                  </h5>
                  <p>:</p>
                  <p className="col-xl-6">{ArticlescategoryName}</p>
                </div>
                <form action="javascript:void(0);" method="POST">
                  <fieldset>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-xl-4 col-form-label">
                        <h5 className="mb-0">
                          <b>Combination</b>
                        </h5>
                      </label>
                      <div>:</div>
                      <div className="col-xl-7">
                        <p className="mb-0">{selectCombination}</p>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>

              {selectCombinationID != "" &&
                selectCombinationID != undefined &&
                selectCombinationID != null ? (
                QrCodeString != null &&
                  QrCodeString != undefined &&
                  QrCodeString != "" ? (
                  <button
                    type="button"
                    className="btn btn-primary shadow-add my-3 m-l-10 m-r-10 btn-lg"
                    onClick={() => {
                      QrcodeCombinationalredycreate();
                    }}
                  >
                    Create QR Code
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={async () => {
                      let response =
                        await CheckCheckAPDynamicQrCodeCountenabled();

                      if (response === true) {
                        QrcodegeneratorVariations();
                      } else {
                        swal(
                          "oops!",
                          "Sorry! to increase your dynamic qrcode count.",
                          "warning"
                        );
                      }
                    }}
                    className="btn btn-primary shadow-add my-3 m-l-10 m-r-10 btn-lg"
                  >
                    Create QR Code
                  </button>
                )
              ) : (
                <></>
              )}

              <button
                type="button"
                onClick={() => {
                  toggleQrCodeModal();
                }}
                className="btn btn-danger btn-lg shadow-add my-3 "
              >
                Discard
              </button>
            </div>
            <div className="col-xl-6">
              <div className="dash-box">
                {/* <img src="../assets/img/user/QR.png" style={{ height: '350px' }}></img> */}
                <div style={{ background: "white", padding: "16px" }}>
                  {selectCombinationID != "" &&
                    selectCombinationID != undefined &&
                    selectCombinationID != null ? (
                    QrCodeString != null &&
                      QrCodeString != undefined &&
                      QrCodeString != "" ? (
                      <QRCode
                        value={QrCodeString}
                        id="qrCodeElAttributecreate"
                        size={210}
                      />
                    ) : (
                      <img
                        src="/assets/img/new-Images/qr-code-scanner.jpg"
                        style={{ height: "210px" }}
                      ></img>
                    )
                  ) : (
                    <></>
                  )}
                </div>

                <div className="my-2">
                  {selectCombinationID != "" &&
                    selectCombinationID != undefined &&
                    selectCombinationID != null ? (
                    QrCodeString != null &&
                      QrCodeString != undefined &&
                      QrCodeString != "" ? (
                      <div className="d-flex justify-content-center">
                        <button
                          type="submit"
                          className="btn btn-warning  m-r-5 m-b-5 "
                          onClick={(e) => {
                            printQrcodeAttributecreate(e);
                          }}
                        >
                          Print{" "}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-warning m-b-5 m-r-5 "
                          onClick={(e) => {
                            downloadQRCodeAttributecreate(e);
                          }}
                        >
                          Download
                        </button>
                        <button
                          type="submit"
                          className="btn btn-warning m-b-5 "
                          onClick={(e) => {
                            toggleToEmailAttributecreate(e);
                          }}
                        >
                          Send
                        </button>
                      </div>
                    ) : (
                      <></>
                    )
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={NewProductQrCodeisOpen}
        toggle={NewProductQrCodeisOpen}
        className="modal-xl"
      >
        <ModalHeader
          toggle={toggleNewProductQrCodeisOpenclose}
          className="modalheader"
        >
          <h4 className="text-white mb-0">Create Product QR code</h4>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-xl-6">
              <div className="row  align-items-center">
                <div className="col-xl-4 col-xs-4">
                  {ArticlesProfileImage ? (
                    <img
                      src={ArticlesProfileImage}
                      alt
                      className="rounded qrcode-article-image"
                    />
                  ) : (
                    <img
                      src="../assets/img/user/noimage.jpg"
                      alt
                      className="rounded qrcode-article-image"
                    />
                  )}
                  <h5 className="m-t-10 mb-0 text-center">{ArticleName}</h5>
                </div>
                <div className="col-xl-4 col-xs-4"></div>
              </div>
              <div className="m-t-30">
                <div className="row">
                  <h5 className="col-xl-4 col-xs-4 mb-0">
                    <b>Article</b>
                  </h5>
                  <div>:</div>
                  <p className="col-xl-6 col-xs-7"> {ArticlesNo}</p>
                </div>
                <div className="row">
                  <h5 className="col-xl-4 col-xs-4 ">
                    <b>Category</b>
                  </h5>
                  <p>:</p>
                  <p className="col-xl-6 col-xs-7">
                    {ArticlescategoryName} {ArticlessubcategoryNewName}
                  </p>
                </div>
                <div>
                  <div>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <h5 className="col-xl-4 col-xs-4 col-form-label mb-0">
                        <b>Vendors</b>
                      </h5>
                      <div>:</div>
                      <div className="col-xl-5 col-xs-5">
                        <select
                          className="default-select2 form-control"
                          onChange={(e) => {
                            onchangeVendor(e);
                          }}
                          value={VendorID}
                        >
                          <option value="">---Select Vendors ---</option>
                          {vendorlist.map((item, i) => {
                            return (
                              <option value={item.value}>{item.text}</option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    {isAttributeshow === true ? (
                      <div className="form-group row m-b-15 d-flex align-items-center">
                        <h5 className="col-xl-4 col-xs-4 col-form-label mb-0">
                          <b>Select Combination </b>
                        </h5>
                        <div>:</div>
                        <div className="col-xl-7 col-xs-7">
                          <select
                            className="default-select2 form-control"
                            onChange={(e) => {
                              onchangeCombinationQrcode(e);
                            }}
                            value={selectCombinationNewID}
                          >
                            <option value="" selected>
                              --- Select Combination ---
                            </option>
                            {CombinationList.map((item) => {
                              return item.attributeValue1 != "" &&
                                item.attributeValue2 != "" &&
                                item.attributeValue3 != "" &&
                                item.attributeValue4 != "" &&
                                item.attributeValue5 != "" ? (
                                <option value={item.id}>
                                  {item.attributeValue1 +
                                    " / " +
                                    item.attributeValue2 +
                                    " / " +
                                    item.attributeValue3 +
                                    " / " +
                                    item.attributeValue4 +
                                    " / " +
                                    item.attributeValue5}
                                </option>
                              ) : item.attributeValue1 != "" &&
                                item.attributeValue2 != "" &&
                                item.attributeValue3 != "" &&
                                item.attributeValue4 != "" &&
                                item.attributeValue5 === "" ? (
                                <option value={item.id}>
                                  {item.attributeValue1 +
                                    " / " +
                                    item.attributeValue2 +
                                    " / " +
                                    item.attributeValue3 +
                                    " / " +
                                    item.attributeValue4}
                                </option>
                              ) : item.attributeValue1 != "" &&
                                item.attributeValue2 != "" &&
                                item.attributeValue3 != "" &&
                                item.attributeValue4 === "" &&
                                item.attributeValue5 === "" ? (
                                <option value={item.id}>
                                  {item.attributeValue1 +
                                    " / " +
                                    item.attributeValue2 +
                                    " / " +
                                    item.attributeValue3}
                                </option>
                              ) : item.attributeValue1 != "" &&
                                item.attributeValue2 != "" &&
                                item.attributeValue3 === "" &&
                                item.attributeValue4 === "" &&
                                item.attributeValue5 === "" ? (
                                <option value={item.id}>
                                  {item.attributeValue1 +
                                    " / " +
                                    item.attributeValue2}
                                </option>
                              ) : item.attributeValue1 != "" &&
                                item.attributeValue2 === "" &&
                                item.attributeValue3 === "" &&
                                item.attributeValue4 === "" &&
                                item.attributeValue5 === "" ? (
                                <option value={item.id}>
                                  {item.attributeValue1}
                                </option>
                              ) : (
                                <></>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <h5 className="col-xl-4 col-xs-4 col-form-label mb-0">
                        <b>Select Batch Number </b>
                      </h5>
                      <div>:</div>
                      <div className="col-xl-5 col-xs-7">
                        <select
                          className="default-select2 form-control"
                          onChange={(e) => {
                            onchangeselectBatchnumber(e);
                          }}
                          value={selectBatchNumbername}
                        >
                          <option value="" selected>
                            --- Select Batch Number ---
                          </option>
                          {batchNumberList.map((item) => {
                            return (
                              <option value={item?._id}>
                                {item?.batchNumber}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col-xl-2 col-xs-2">
                        <button
                          className="btn btn-primary btn-sm shadow-add"
                          onClick={(e) => {
                            batchnumbertoggle();
                          }}
                        >
                          <i class="ion ion-md-add fa-2x fa-fw text-white"></i>
                        </button>
                      </div>
                    </div>

                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <h5 className="col-xl-4 col-xs-4 col-form-label mb-0">
                        <b>Manufacture date</b>
                      </h5>
                      <div>:</div>
                      <div className="col-xl-7 col-xs-7">
                        <DatePicker
                          className="form-control"
                          dateFormat={"dd/MM/yyyy"}
                          placeholderText="DD/MM/YYYY"
                          selected={ManufactureDate}
                          // maxDate={new Date()}
                          // onChange={(date: Date) => setManufactureDate(date)}
                          onChange={(date) => {
                            onchangeManufactureDate(date);
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <h5 className="col-xl-4 col-xs-4 col-form-label mb-0">
                        <b>Expiry date</b>
                      </h5>
                      <div>:</div>
                      <div className="col-xl-7 col-xs-7">
                        {/* <input type="email" className="form-control" id="exampleInputEmail1" placeholder="Expiry date" /> */}
                        <DatePicker
                          className="form-control"
                          dateFormat={"dd/MM/yyyy"}
                          placeholderText="DD/MM/YYYY"
                          selected={ExpiryDate}
                          // minDate={new Date()}
                          // onChange={(date: Date) => setExpiryDate(date)}
                          onChange={(date) => {
                            onchangeExpiryDate(date);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="dash-box">
                <h4 className="mb-3">Product QR code</h4>
                {selectCombinationNewID != "" &&
                  selectCombinationNewID != undefined &&
                  selectCombinationNewID != null ? (
                  QrCodeStringnew != null &&
                    QrCodeStringnew != undefined &&
                    QrCodeStringnew != "" ? (
                    <>
                      <QRCode
                        value={QrCodeStringnew}
                        id="qrCodeEl"
                        size={200}
                      />
                      <p>Attrubute</p>
                    </>
                  ) : (
                    <img
                      src="/assets/img/new-Images/qr-code-scanner.jpg"
                      style={{ height: "200px" }}
                    ></img>
                  )
                ) : QrCodeStringnew != null &&
                  QrCodeStringnew != undefined &&
                  QrCodeStringnew != "" ? (
                  <QRCode
                    value={QrCodeStringnew}
                    id="ArticleqrCodeNewEl"
                    size={200}
                  />
                ) : (
                  <img
                    src="/assets/img/new-Images/qr-code-scanner.jpg"
                    style={{ height: "200px" }}
                  ></img>
                )}

                <div className="my-2">
                  {selectCombinationNewID != "" &&
                    selectCombinationNewID != undefined &&
                    selectCombinationNewID != null ? (
                    QrCodeStringnew != null &&
                      QrCodeStringnew != undefined &&
                      QrCodeStringnew != "" ? (
                      <div className="d-flex justify-content-center">
                        <button
                          type="submit"
                          className="btn btn-warning  m-r-5 m-b-5 btn-sm "
                          onClick={printQrcode}
                        >
                          Print{" "}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-warning   m-r-5 m-b-5 btn-sm"
                          onClick={downloadQRCode}
                        >
                          Download
                        </button>
                        <button
                          type="submit"
                          className="btn btn-warning m-r-5 m-b-5  btn-sm "
                          onClick={() => {
                            toggleToEmailAttributecreate();
                          }}
                        >
                          Send
                        </button>
                      </div>
                    ) : (
                      <></>
                    )
                  ) : QrCodeStringnew != null &&
                    QrCodeStringnew != undefined &&
                    QrCodeStringnew != "" ? (
                    <div className="d-flex justify-content-center">
                      <button
                        type="submit"
                        className="btn btn-warning  m-r-5 m-b-5 "
                        onClick={printQrcodeArticle}
                      >
                        Print
                      </button>
                      <button
                        type="submit"
                        className="btn btn-warning m-b-5 m-r-5 "
                        onClick={downloadQRCodeArticle}
                      >
                        Download
                      </button>

                      <button
                        type="submit"
                        className="btn btn-warning m-r-5 m-b-5"
                        onClick={() => {
                          toggleToEmail();
                        }}
                      >
                        Send
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="dash-box">
                <h4 className="mb-3">Create production QR code</h4>
                <div className="d-flex align-items-center justify-content-center ">
                  <label className=" m-r-5 col-form-label">Enter qty :</label>
                  <input
                    type="text"
                    className="form-control qtyinputbox"
                    placeholder="5625"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      OnchangedQrCodeQty(e);
                    }}
                    value={QrcodeQty}
                  />
                </div>
                <div className="mt-3">
                  <div className="row justify-content-center">
                    <button
                      type="submit"
                      className="btn btn-success m-b-10 shadow-add"
                      onClick={async (e) => {
                        if (
                          QrcodeQty > 0 &&
                          QrcodeQty !== null &&
                          QrcodeQty !== "" &&
                          QrcodeQty !== undefined
                        ) {
                          try {
                            let response = await CheckBulkQRcodecount();
                            if (response === true || response === "true") {
                              DuplicateQrcodeCreateNew();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Bulk qrcode .",
                                "warning"
                              );
                            }
                          } catch (error) {
                            console.log("error!", error);
                          }
                        }
                      }}
                    >
                      Create production QR Code
                    </button>
                  </div>
                  {DuplicateQrcodeList.length > 0 ? (
                    <div style={{ height: "300px", overflow: "auto" }}>
                      <h5 className="text-center">Production QR Codes</h5>
                      <div className="m-b-20">
                        {DuplicateQrcodeList.map((item, i) => {
                          return (
                            <QRCode
                              value={item}
                              id={"qrCodeElDuplicate" + i}
                              key={i}
                              size={70}
                              style={{
                                marginLeft: "8px",
                                marginRight: "8px",
                                marginBottom: "5px",
                              }}
                            />
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <> </>
                  )}

                  <div className="my-2">
                    {DuplicateQrcodeList.length > 0 ? (
                      <div className="d-flex justify-content-center">
                        <button
                          type="submit"
                          className="btn btn-warning  m-r-5 m-b-5 btn-sm"
                          onClick={(e) => {
                            printQRDuplicate();
                          }}
                        >
                          Print{" "}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-warning m-b-5 btn-sm"
                          onClick={downloadQRDuplicate}
                        >
                          Download
                        </button>
                        {/* <button type="submit" className="btn btn-warning m-l-5 m-b-5  btn-sm" onClick={(e) => { sendpdfEmail() }}>Send
                                                </button> */}
                        <button
                          type="submit"
                          className="btn btn-warning m-l-5 m-b-5  btn-sm"
                          onClick={() => {
                            toggleDuplicateSendEmail();
                          }}
                        >
                          Send
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button
              type="submit"
              className="btn btn-danger shadow-add my-3 "
              onClick={() => {
                toggleNewProductQrCodeisOpenclose();
              }}
            >
              Discard
            </button>

            {selectCombinationID != "" &&
              selectCombinationID != undefined &&
              selectCombinationID != null ? (
              <button
                type="button"
                onClick={async () => {
                  let response = await CheckCheckAPDynamicQrCodeCountenabled();
                  if (response === true) {
                    //Qrcodegenerator();
                    Qrcodegenerator();
                  } else {
                    swal(
                      "oops!",
                      "Sorry! to increase your dynamic qrcode count.",
                      "warning"
                    );
                  }
                }}
                className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
              >
                Create Pre-Production QR Code Attribute
              </button>
            ) : (
              <button
                type="button"
                onClick={async () => {
                  let response = await CheckCheckAPDynamicQrCodeCountenabled();
                  if (response === true) {
                    QrcodegeneratorArticle();
                  } else {
                    swal(
                      "oops!",
                      "Sorry! to increase your dynamic qrcode count.",
                      "warning"
                    );
                  }
                }}
                className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
              >
                Create Pre-Production QR Code
              </button>
            )}
          </div>
        </ModalBody>

      </Modal>
      <Modal isOpen={batchnumberisOpen} toggle={batchnumbertoggle} className="">
        <ModalHeader toggle={batchnumbertoggle} className="modalheader">
          <h4 className="text-white mb-0">Add Batch Number</h4>
        </ModalHeader>
        <ModalBody>
          <div className="form-group ">
            <label htmlFor="exampleInputEmail1 " className="">
              Batch number
            </label>
            <input
              type="email"
              className="form-control"
              id="exampleInputEmail1"
              placeholder="Select Batch number"
              value={BatchNumber}
              maxLength={30}
              onChange={(e) => {
                setBatchnumber(e.target.value);
                setBatchNumberError("");
              }}
            />
            <p style={{ textAlign: "right", fontSize: 12, color: "red" }}>
              {BatchNumber.length}/30
            </p>
            {BatchNumberError.length > 0 ? (
              <span style={{ color: "red" }}>{BatchNumberError}</span>
            ) : (
              ""
            )}
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={(e) => {
                addbatchnumber();
              }}
              className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
            >
              Add
            </button>
            <button
              type="button"
              onClick={(e) => {
                setBatchnumber("");
                batchnumbertoggle();
              }}
              className="btn btn-danger shadow-add my-3 "
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>

      {/* Done */}
      <Modal isOpen={isToEamil} toggle={toggleToEmail}>
        <ModalHeader toggle={toggleToEmail} className="modalheader">
          <h5 className="text-white mb-0">To Email</h5>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12">
            <label
              htmlFor="exampleInputPassword1"
              className="mt-2 d-flex align-items-center"
            >
              <h5 className="mb-0">Add To Email</h5>
              <button
                type="button"
                className="m-l-10 btn btn-link"
                onClick={SubToEmailaddClick}
              >
                <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
              </button>
            </label>
          </div>
          <div className="form-group">
            {createSubToEmailUI()}
            {isToemailMaltiple === true ? (
              <span style={{ color: "red", marginLeft: 6 }}>
                {"Email id dublicate"}
              </span>
            ) : (
              <></>
            )}
            {ToemailEmptyError.length > 0 && (
              <span style={{ color: "red", marginLeft: 6 }}>
                {ToemailEmptyError}
              </span>
            )}
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={() => {
                QRCodeArticleSend();
              }}
              className="btn btn-sm btn-primary m-r-5 shadow-add "
            >
              Send Email
            </button>
            <button
              type="button"
              onClick={() => {
                toggleToEmail();
              }}
              className="btn btn-sm btn-danger shadow-add "
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>
      {/* Done */}
      <Modal isOpen={isToEamilAttribute} toggle={toggleToEmailAttributecreate}>
        <ModalHeader
          toggle={toggleToEmailAttributecreate}
          className="modalheader"
        >
          <h5 className="text-white mb-0">To Email</h5>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12">
            <label
              htmlFor="exampleInputPassword1"
              className="mt-2 d-flex align-items-center"
            >
              <h5 className="mb-0">Add To Email</h5>
              <button
                type="button"
                className="m-l-10 btn btn-link"
                onClick={SubToEmailaddClick}
              >
                <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
              </button>
            </label>
          </div>
          <div className="form-group">
            {createSubToEmailUI()}
            {isToemailMaltiple === true ? (
              <span style={{ color: "red", marginLeft: 6 }}>
                {"Email id dublicate"}
              </span>
            ) : (
              <></>
            )}
            {ToemailEmptyError.length > 0 && (
              <span style={{ color: "red", marginLeft: 6 }}>
                {ToemailEmptyError}
              </span>
            )}
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={() => {
                QRCodeArticleSendAttributecreate();
              }}
              className="btn btn-sm btn-primary m-r-5 shadow-add "
            >
              Send Email
            </button>
            <button
              type="button"
              onClick={() => {
                toggleToEmailAttributecreate();
              }}
              className="btn btn-sm btn-danger shadow-add "
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>

      {/* Done */}
      <Modal isOpen={isToEamilBulk} toggle={toggleToEmailBulk}>
        <ModalHeader toggle={toggleToEmailBulk} className="modalheader">
          <h5 className="text-white mb-0">To Email</h5>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12">
            <label
              htmlFor="exampleInputPassword1"
              className="mt-2 d-flex align-items-center"
            >
              <h5 className="mb-0">Add To Email</h5>
              <button
                type="button"
                className="m-l-10 btn btn-link"
                onClick={SubToEmailaddClick}
              >
                <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
              </button>
            </label>
          </div>
          <div className="form-group">
            {createSubToEmailUI()}
            {isToemailMaltiple === true ? (
              <span style={{ color: "red", marginLeft: 6 }}>
                {"Email id dublicate"}
              </span>
            ) : (
              <></>
            )}
            {ToemailEmptyError.length > 0 && (
              <span style={{ color: "red", marginLeft: 6 }}>
                {ToemailEmptyError}
              </span>
            )}
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={() => {
                QRCodeArticleSendBulk();
              }}
              className="btn btn-sm btn-primary m-r-5 shadow-add "
            >
              Send Email
            </button>
            <button
              type="button"
              onClick={() => {
                toggleToEmailBulk();
              }}
              className="btn btn-sm btn-danger shadow-add "
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>

      {/* //Praveen new Work */}
      <Modal isOpen={modalQrcode} toggle={toggleQrcode} className="modal-xl">
        <ModalHeader toggle={ModelClosed} className="modalheader">
          <h4 className="text-white mb-0">Create Production QR code</h4>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-xl-6">
              <div className="row  align-items-center">
                <div className="col-xl-4 col-xs-4">
                  <img
                    src={totalQrcodeImage}
                    className="img-fluid"
                    style={{ height: "140px" }}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = "../assets/img/new-images/images.png";
                    }}
                  ></img>
                  <h5 className="m-t-10 mb-0 text-center">
                    {totalQrcodeArticlename ? totalQrcodeArticlename : "N/A"}
                  </h5>
                </div>
                <div className="col-xl-4 col-xs-4"></div>
              </div>
              <div className="m-t-30">
                <div className="row">
                  <h5 className="col-xl-4 col-xs-4 mb-0">
                    <b>Article</b>
                  </h5>
                  <div>:</div>
                  <p className="col-xl-6 col-xs-7">
                    {" "}
                    {totalQrcodeArticlenumber
                      ? totalQrcodeArticlenumber
                      : "N/A"}
                  </p>
                </div>
                <div className="row">
                  <h5 className="col-xl-4 col-xs-4 ">
                    <b>Category</b>
                  </h5>
                  <p>:</p>
                  <p className="col-xl-6 col-xs-7">
                    {totalQrcodecategory ? totalQrcodecategory : "N/A"}
                  </p>
                </div>
                <div className="row">
                  <h5 className="col-xl-4 col-xs-4 ">
                    <b>Vendors</b>
                  </h5>
                  <p>:</p>
                  <p className="col-xl-6 col-xs-7">
                    {bulkQrcodeInformation?.vendorName
                      ? bulkQrcodeInformation?.vendorName
                      : "N/A"}
                  </p>
                </div>
                <div className="row">
                  <h5 className="col-xl-4 col-xs-4 ">
                    <b>Combination</b>
                  </h5>
                  <p>:</p>
                  <p className="col-xl-6 col-xs-7">
                    {bulkQrcodeInformation?.productAttributeName
                      ? bulkQrcodeInformation?.productAttributeName
                      : "N/A"}
                  </p>
                </div>
                <div className="row">
                  <h5 className="col-xl-4 col-xs-4 ">
                    <b>Batch Number</b>
                  </h5>
                  <p>:</p>
                  <p className="col-xl-6 col-xs-7">
                    {bulkQrcodeInformation?.batchnumber
                      ? bulkQrcodeInformation?.batchnumber
                      : "N/A"}
                  </p>
                </div>
                <div className="row">
                  <h5 className="col-xl-4 col-xs-4 ">
                    <b>Manufacture date</b>
                  </h5>
                  <p>:</p>
                  <p className="col-xl-6 col-xs-7">
                    {bulkQrcodeInformation.manufacturedate
                      ? Moment(bulkQrcodeInformation?.manufacturedate).format(
                        "DD-MM-YYYY"
                      )
                      : "N/A"}
                  </p>
                </div>
                <div className="row">
                  <h5 className="col-xl-4 col-xs-4 ">
                    <b>Expiry date</b>
                  </h5>
                  <p>:</p>
                  <p className="col-xl-6 col-xs-7">
                    {bulkQrcodeInformation?.expirydate
                      ? Moment(bulkQrcodeInformation?.expirydate).format(
                        "DD-MM-YYYY"
                      )
                      : "N/A"}
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    ModelClosed();
                  }}
                  className="btn btn-danger btn-lg shadow-add my-3 "
                >
                  Discard
                </button>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="dash-box">
                <h4 className="mb-3">Product QR code</h4>
                {QrCodeString != null &&
                  QrCodeString != undefined &&
                  QrCodeString != "" ? (
                  <>
                    <QRCode value={QrCodeString} id="qrCodeEl" size={200} />
                    <p>Attrubute</p>
                  </>
                ) : (
                  <img
                    src="/assets/img/new-Images/qr-code-scanner.jpg"
                    style={{ height: "200px" }}
                  ></img>
                )}

                <div className="my-2">
                  {QrCodeString != null &&
                    QrCodeString != undefined &&
                    QrCodeString != "" ? (
                    <div className="d-flex justify-content-center">
                      <button
                        type="submit"
                        className="btn btn-warning  m-r-5 m-b-5 btn-sm "
                        onClick={printQrcode}
                      >
                        Print{" "}
                      </button>
                      <button
                        type="submit"
                        className="btn btn-warning   m-r-5 m-b-5 btn-sm"
                        onClick={downloadQRCode}
                      >
                        Download
                      </button>
                      <button
                        type="submit"
                        className="btn btn-warning m-r-5 m-b-5  btn-sm "
                        onClick={() => {
                          toggleToEmailAttributecreate();
                        }}
                      >
                        Send
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="dash-box">
                <h4 className="mb-3">Create production QR code</h4>
                <div className="d-flex align-items-center justify-content-center ">
                  <label className=" m-r-5 col-form-label">Enter qty :</label>
                  <input
                    type="text"
                    className="form-control qtyinputbox"
                    placeholder="5625"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      OnchangedQrCodeQty(e);
                    }}
                    value={QrcodeQty}
                  />
                </div>
                <div className="mt-3">
                  <div className="row justify-content-center">
                    <button
                      type="submit"
                      className="btn btn-success m-b-10 shadow-add  btn-sm"
                      // onClick={DuplicateQrcodeCreate}
                      onClick={async (e) => {
                        try {
                          let response = await CheckBulkQRcodecount();
                          if (response === true || response === "true") {
                            DuplicateQrcodeCreate();
                          } else {
                            swal(
                              "oops!",
                              "Sorry! to increase your Bulk qrcode .",
                              "warning"
                            );
                          }
                        } catch (error) {
                          console.log("error!", error);
                        }
                      }}
                    >
                      Create production QR Code
                    </button>
                  </div>
                  {DuplicateQrcodeList.length > 0 ? (
                    <div style={{ height: "300px", overflow: "auto" }}>
                      <h5 className="text-center">Duplicate QR Code</h5>
                      <div className="m-b-20">
                        {DuplicateQrcodeList.map((item, i) => {
                          return (
                            <QRCode
                              value={item}
                              id={"qrCodeElDuplicate" + i}
                              key={i}
                              size={70}
                              style={{
                                marginLeft: "8px",
                                marginRight: "8px",
                                marginBottom: "5px",
                              }}
                            />
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <> </>
                  )}

                  <div className="my-2">
                    {DuplicateQrcodeList.length > 0 ? (
                      <div className="d-flex justify-content-center">
                        <button
                          type="submit"
                          className="btn btn-warning  m-r-5 m-b-5 btn-sm"
                          onClick={(e) => {
                            printQRDuplicate();
                          }}
                        >
                          Print{" "}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-warning m-b-5 btn-sm"
                          onClick={downloadQRDuplicate}
                        >
                          Download
                        </button>
                        <button
                          type="submit"
                          className="btn btn-warning m-l-5 m-b-5  btn-sm"
                          onClick={() => {
                            toggleDuplicateSendEmail();
                          }}
                        >
                          Send
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={isDuplicateToEamil} toggle={toggleDuplicateSendEmail}>
        <ModalHeader toggle={toggleDuplicateSendEmail} className="modalheader">
          <h5 className="text-white mb-0">To Email</h5>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12">
            <label
              htmlFor="exampleInputPassword1"
              className="mt-2 d-flex align-items-center"
            >
              <h5 className="mb-0">Add To Email</h5>
              <button
                type="button"
                className="m-l-10 btn btn-link"
                onClick={SubToEmailaddClick}
              >
                <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
              </button>
            </label>
          </div>
          <div className="form-group">
            {createSubToEmailUI()}
            {isToemailMaltiple === true ? (
              <span style={{ color: "red", marginLeft: 6 }}>
                {"Email id dublicate"}
              </span>
            ) : (
              <></>
            )}
            {ToemailEmptyError.length > 0 && (
              <span style={{ color: "red", marginLeft: 6 }}>
                {ToemailEmptyError}
              </span>
            )}
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={() => {
                sendpdfEmail();
              }}
              className="btn btn-sm btn-primary m-r-5 shadow-add "
            >
              Send Email
            </button>
            <button
              type="button"
              onClick={() => {
                toggleDuplicateSendEmail();
              }}
              className="btn btn-sm btn-danger shadow-add "
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
const customStyles = {
  title: {
    style: {
      fontColor: "red",
      fontWeight: "900",
    },
  },
  rows: {
    style: {
      minHeight: "67px", // override the row height
      borderWidth: 1,
      borderColor: "#e4e7ea",
    },
  },
  headCells: {
    style: {
      fontSize: "15px",
      fontWeight: "600",
    },
  },
  cells: {
    style: {
      fontSize: "15px",
      fontWeight: "700",
    },
  },
};

export default Productqrcode;
